/* CUSTOMLY v4 \u2014 presupuesto, configurador, WhatsApp din\u00e1mico, lead en background y tracking.
   Fuente de verdad comercial: window.CUSTOMLY (snippets/customly-config.liquid \u2190 Configuraci\u00f3n del tema).
   UI STATE (form | result | custom) separado de LEAD STATE (idle | submitting | submitted | error):
   calcular NUNCA navega ni resetea; el lead viaja por fetch en segundo plano. */
(function () {
  'use strict';

  var C = window.CUSTOMLY || {};
  var dataLayer = (window.dataLayer = window.dataLayer || []);
  var fired = {};

  function dl(event, data, once) {
    if (once && fired[event]) return;
    fired[event] = true;
    var payload = { event: event };
    if (data) for (var k in data) payload[k] = data[k];
    dataLayer.push(payload);
  }

  /* v14.2: conversion unica por sesion -> GA4 (generate_lead via dataLayer/GTM) + evento de cliente de Shopify
     (lo pueden leer las apps de Google, Meta o TikTok desde Configuracion -> Eventos del cliente). */
  function trackLead(method, where) {
    var done = false;
    try { done = sessionStorage.getItem('customly_lead_done') === '1'; } catch (e) {}
    if (done) return;
    try { sessionStorage.setItem('customly_lead_done', '1'); } catch (e) {}
    var p = {};
    try { p = buildLeadPayload(); } catch (e) {}
    dataLayer.push({ event: 'generate_lead', method: method, form_location: where, currency: 'EUR',
      value: p.price_total || 0, group_size: p.group_size || null, garment: p.garment_label || null, tier: p.tier || null });
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('customly_lead', { method: method, location: where, group_size: p.group_size || null,
          garment: p.garment_label || null, tier: p.tier || null, value: p.price_total || 0, currency: 'EUR' });
      }
    } catch (e) {}
  }

  /* ---------- utilidades ---------- */
  function parsePricing(raw) {
    if (!raw) return [];
    try {
      var clean = String(raw).replace(/\/\/[^\n]*/g, '');
      var arr = JSON.parse(clean);
      if (!Array.isArray(arr)) return [];
      return arr
        .map(function (t) {
          return { min: Number(t.min), max: Number(t.max), price: Number(t.precio != null ? t.precio : t.price) };
        })
        .filter(function (t) { return isFinite(t.min) && isFinite(t.max) && isFinite(t.price); })
        .sort(function (a, b) { return a.min - b.min; });
    } catch (e) { return []; }
  }
  var GARMENTS = {};
  (function () {
    var src = C.garments || { hoodie: { label: 'Hoodie', pricingRaw: C.pricingRaw } };
    for (var k in src) {
      var tiers = parsePricing(src[k] && src[k].pricingRaw);
      var ut = parsePricing(src[k] && src[k].ultraRaw);
      GARMENTS[k] = { label: (src[k] && src[k].label) || k, tiers: tiers.length ? tiers : null, ultra: ut.length ? ut : null };
    }
    if (!GARMENTS.hoodie) GARMENTS.hoodie = { label: 'Hoodie', tiers: parsePricing(C.pricingRaw) || null };
  })();
  var TIERS = (GARMENTS.hoodie && GARMENTS.hoodie.tiers) || [];
  var MIN = parseInt(C.minPersonas, 10) || (TIERS.length ? TIERS[0].min : 1);

  function parseNum(v) {
    if (v == null || v === '') return null;
    var n = parseFloat(String(v).replace(',', '.').replace(/[^\d.]/g, ''));
    return isFinite(n) ? n : null;
  }
  var PERSOS = (C.personalizations || []).map(function (p) {
    return { id: p.id, label: p.label, surcharge: parseNum(p.surcharge) };
  });
  function persoById(id) {
    for (var i = 0; i < PERSOS.length; i++) if (PERSOS[i].id === id) return PERSOS[i];
    return null;
  }
  function selectedPersos() {
    return (state.persos || []).map(persoById).filter(Boolean);
  }
  function surchargeTotal() {
    return selectedPersos().reduce(function (s, p) { return s + (p.surcharge || 0); }, 0);
  }
  function currentGarment() {
    var id = state.prenda && GARMENTS[state.prenda] ? state.prenda : 'hoodie';
    /* VERSION_CARLOS: en Ultra Premium se usa su propia tabla (desde 25 prendas) */
    return { id: id, label: GARMENTS[id].label, tiers: state.tier === 'ultra' ? GARMENTS[id].ultra : GARMENTS[id].tiers };
  }
  function findTier(n) {
    var tiers = currentGarment().tiers || [];
    for (var i = 0; i < tiers.length; i++) if (n >= tiers[i].min && n <= tiers[i].max) return tiers[i];
    return null;
  }
  function earlyBirdActive() {
    var e = C.earlyBird; if (!e || !e.until || !e.pct) return false;
    try { return new Date() <= new Date(e.until + 'T23:59:59'); } catch (x) { return false; }
  }
  function fmtPrice(x) { return x.toFixed(2).replace('.', ',') + ' \u20ac'; }
  function normHex(v) {
    if (!v) return null;
    v = String(v).trim().replace(/^#/, '');
    if (/^[0-9a-fA-F]{3}$/.test(v)) v = v[0] + v[0] + v[1] + v[1] + v[2] + v[2];
    if (!/^[0-9a-fA-F]{6}$/.test(v)) return null;
    return '#' + v.toUpperCase();
  }
  function hexToRgb(hex) {
    var h = normHex(hex); if (!h) return null;
    return { r: parseInt(h.slice(1, 3), 16), g: parseInt(h.slice(3, 5), 16), b: parseInt(h.slice(5, 7), 16) };
  }
  function luminance(hex) {
    var c = hexToRgb(hex); if (!c) return 0;
    var f = function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    return 0.2126 * f(c.r) + 0.7152 * f(c.g) + 0.0722 * f(c.b);
  }
  function contrast(a, b) {
    var l1 = luminance(a), l2 = luminance(b);
    return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
  }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(); }
  function digits(s) { return String(s || '').replace(/\D/g, ''); }
  function validPhone(pref, tel) {
    var d = digits(tel);
    if (pref === '+34') return /^[6789]\d{8}$/.test(d);
    return /^\d{6,14}$/.test(d);
  }

  /* ---------- estado persistente ---------- */
  var state = {};
  try { state = JSON.parse(sessionStorage.getItem('customly_state') || '{}') || {}; } catch (e) { state = {}; }
  function save() { try { sessionStorage.setItem('customly_state', JSON.stringify(state)); } catch (e) {} }

  /* VERSION_CARLOS: diseño compartido por enlace (#cz=...) -> se carga la configuracion de quien lo compartio */
  var SHARE_KEYS = ['tier', 'prenda', 'prendaLabel', 'hoodie', 'dsrc', 'group', 'designCat', 'design', 'designImg', 'designOverlay',
    'print', 'print2', 'persos', 'bandera', 'scopes', 'logoOpts', 'iniciales', 'nombreGrupo', 'namesText', 'namesBig', 'namesTitle', 'namesFoot', 'namesStyle', 'personas', 'destino', 'pais', 'fileUrl', 'fileName'];
  function encodeShare(obj) {
    var json = JSON.stringify(obj);
    return btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function decodeShare(s) {
    s = s.replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '=';
    return JSON.parse(decodeURIComponent(escape(atob(s))));
  }
  /* lista de nombres del diseño «Con los nombres de la clase» (accesible también desde el lead y el WhatsApp) */
  function namesList() {
    return String(state.namesText || '').split(/[\n,;]+/).map(function (s) { return s.trim().replace(/\s+/g, ' '); }).filter(Boolean).slice(0, 160);
  }
  function shareConfig() {
    var o = {}; SHARE_KEYS.forEach(function (k) { if (state[k] != null && state[k] !== '') o[k] = state[k]; });
    return o;
  }
  try {
    var hm = window.location.hash.match(/[#&]cz=([A-Za-z0-9_-]+)/);
    if (hm) {
      var sc = decodeShare(hm[1]);
      SHARE_KEYS.forEach(function (k) { if (k in sc) state[k] = sc[k]; });
      state.sharedView = true; state.wizStep = 7;
      save();
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    var frase = sessionStorage.getItem('customly_frase');
    if (frase) { state.frase = frase; sessionStorage.removeItem('customly_frase'); save(); }
  } catch (e) {}

  try {
    var utm = JSON.parse(sessionStorage.getItem('customly_utm') || '{}') || {};
    var qs = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'ref'].forEach(function (k) {
      if (qs.get(k)) utm[k] = qs.get(k);
    });
    sessionStorage.setItem('customly_utm', JSON.stringify(utm));
  } catch (e) {}
  function getUtm() { try { return JSON.parse(sessionStorage.getItem('customly_utm') || '{}'); } catch (e) { return {}; } }

  /* ---------- motor central de precio por volumen ---------- */
  function getPricingForQuantity(quantity, priceTable) {
    var q = parseInt(quantity, 10);
    var out = { currentPrice: null, nextThreshold: null, nextPrice: null, peopleNeeded: null, savingPerPerson: null };
    if (!isFinite(q) || !priceTable || !priceTable.length) return out;
    var sorted = priceTable.slice().sort(function (a, b) { return a.min - b.min; });
    for (var i = 0; i < sorted.length; i++) {
      if (q >= sorted[i].min && q <= sorted[i].max) {
        out.currentPrice = sorted[i].price;
        var next = sorted[i + 1] || null;
        if (next && next.price < sorted[i].price) {
          out.nextThreshold = next.min;
          out.nextPrice = next.price;
          out.peopleNeeded = next.min - q;
          out.savingPerPerson = Math.round((sorted[i].price - next.price) * 100) / 100;
        }
        break;
      }
    }
    return out;
  }

  /* ---------- payload de lead (listo para WhatsApp Business API / CRM) ---------- */
  function buildLeadPayload() {
    var nPers = state.personas ? parseInt(state.personas, 10) : null;
    var g = currentGarment();
    var g0 = currentGarment(), tier = nPers && g0.tiers ? findTier(nPers) : null;
    var sup = surchargeTotal();
    var unit = tier ? Math.round((tier.price + sup) * 100) / 100 : null;
    return {
      phone: state.prefijo && state.telefono ? state.prefijo + digits(state.telefono) : null,
      group_size: nPers,
      garment: g.id,
      garment_label: state.prenda ? g.label : null,
      garment_priced: !!g0.tiers,
      personalizations: selectedPersos().map(function (p) { return { id: p.id, label: p.label, surcharge: p.surcharge }; }),
      surcharge_total: sup || 0,
      price_base: tier ? tier.price : null,
      price_per_person: unit,
      organizer_free: !!(unit && nPers && C.organizerFreeFrom && nPers >= C.organizerFreeFrom),
      price_total: unit && nPers ? Math.round(unit * (nPers - (C.organizerFreeFrom && nPers >= C.organizerFreeFrom ? 1 : 0)) * 100) / 100 : null,
      heard_from: state.canal || null,
      initials_text: (state.persos || []).indexOf('iniciales') > -1 && state.iniciales ? String(state.iniciales).toUpperCase() : null,
      design_name: (state.persos || []).indexOf('nombre') > -1 && state.nombreGrupo ? state.nombreGrupo : null,
      phrase: state.frase || null,
      names_design: state.dsrc === 'names' ? { count: namesList().length, number: state.namesBig || null, title: state.namesTitle || null, footer: state.namesFoot || null, style: state.namesStyle || 'numero', names: namesList() } : null,
      referred_by: (getUtm() || {}).ref || null,
      classes_in_course: state.clasesCurso > 1 ? state.clasesCurso : null,
      early_bird: earlyBirdActive() ? C.earlyBird.label : null,
      vat_included: true,
      submitted_at: new Date().toISOString(),
      group_type: state.group || null,
      hoodie_color: state.hoodie || null,
      hoodie_color_label: (function () { try {
        if (!state.hoodie) return null;
        var el = document.querySelector('[data-sw-hex="' + state.hoodie.toUpperCase() + '"] .lbl') || document.querySelector('[data-sw-hex="' + state.hoodie.toLowerCase() + '"] .lbl');
        return el ? el.textContent : null;
      } catch (e) { return null; } })(),
      print_color: state.print || null,
      print_color_2: state.print2 || null,
      flag: state.bandera && state.bandera !== 'Sin bandera' && (state.persos || []).indexOf('bandera') > -1 ? state.bandera : null,
      design_reference: state.design || null,
      tier: state.tier || null,
      design_source: state.dsrc || null,
      design_file: state.fileName || null,
      design_file_url: state.fileUrl || null,
      design_help: !!state.designHelp,
      logo_options: state.dsrc === 'own' && state.logoOpts && (state.logoOpts.bg || state.logoOpts.mono) ? [state.logoOpts.bg ? 'quitar fondo' : null, state.logoOpts.mono ? 'un solo color' : null].filter(Boolean) : null,
      scopes: state.scopes || {},
      destination: state.destino ? { zone: state.destino, country: state.destino === 'Internacional' ? (state.pais || null) : null } : null,
      custom_text: (state.persos || []).indexOf('nombre') > -1 && state.nombre ? state.nombre : null,
      initials_selected: (state.persos || []).indexOf('iniciales') > -1,
      source: state.source || 'web',
      page: window.location.pathname,
      utm: getUtm()
    };
  }

  /* ---------- WhatsApp: copy centralizado + builder unico (todos los CTAs pasan por aqui) ---------- */
  var EMOJI = {
    wave: '\u{1F44B}',
    cool: '\u{1F60E}',
    people: '\u{1F465}',
    group: '\u{1F393}',
    garment: '\u{1F455}',
    art: '\u{1F3A8}',
    thread: '\u{1F9F5}',
    sparkle: '\u{2728}',
    writing: '\u{270D}\u{FE0F}',
    money: '\u{1F4B8}',
    receipt: '\u{1F9FE}',
    flag: '\u{1F6A9}',
    fire: '\u{1F525}',
    bulb: '\u{1F4A1}',
    star: '\u{2B50}',
    box: '\u{1F4E6}'
  };
  var COPY = {
    hey: '\u00a1Hey! ' + EMOJI.wave,
    intro: 'Acabo de montar mi idea en Customly y me gustar\u00eda que le dierais forma ' + EMOJI.cool,
    group: EMOJI.group + ' Grupo: ',
    garment: EMOJI.garment + ' Prenda: ',
    designLiked: EMOJI.art + ' Dise\u00f1o que me ha gustado: ',
    designOwn: EMOJI.art + ' Dise\u00f1o: Tengo mi propia idea',
    garmentColor: EMOJI.thread + ' Color de la prenda: ',
    printColor: EMOJI.sparkle + ' Color del dise\u00f1o: ',
    text: EMOJI.writing + ' Nombre: ',
    extras: EMOJI.sparkle + ' Extras elegidos:',
    bullet: '\u2022 ',
    flag: EMOJI.flag + ' Bandera: ',
    price: EMOJI.money + ' Precio calculado: ',
    perPerson: '/persona',
    vat: EMOJI.receipt + ' IVA incluido',
    pricePending: EMOJI.money + ' Precio: pendiente de presupuesto personalizado',
    tier: EMOJI.star + ' Gama: ',
    designFile: EMOJI.art + ' Dise\u00f1o: Traigo mi propio dise\u00f1o',
    designHelp: EMOJI.art + ' Dise\u00f1o: Quiero que me ayud\u00e9is con el dise\u00f1o',
    shipping: EMOJI.box + ' Env\u00edo: ',
    scopeAll: 'Todo el grupo',
    scopePartial: 'Solo una parte del grupo',
    closing: '\u00bfMe ayud\u00e1is a preparar una propuesta de dise\u00f1o? ' + EMOJI.fire
  };

  function isOwnIdea(d) {
    d = String(d || '').toLowerCase();
    return d.indexOf('propia') > -1 || d.indexOf('propio') > -1;
  }
  /* v14: iconos SVG monocolor para la interfaz (los emojis solo viven dentro del texto de WhatsApp) */
  function svgI(d) { return '<svg class="icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; }
  var ICON = {
    shirt: svgI('<path d="M8.5 3.5L3 6.5l2 4.5 2-1V20.5h10V10l2 1 2-4.5-5.5-3a3.5 3 0 0 1-7 0z"/>'),
    sparkles: svgI('<path d="M11 3l1.6 4.4L17 9l-4.4 1.6L11 15l-1.6-4.4L5 9l4.4-1.6z"/>'),
    flag: svgI('<path d="M5 21V4"/><path d="M5 4.5h12l-2 4 2 4H5"/>'),
    image: svgI('<rect x="3" y="4.5" width="18" height="15" rx="2"/><circle cx="9" cy="10" r="1.8"/><path d="M21 16l-5.5-5L6 19.5"/>'),
    trend: svgI('<path d="M3 17l6-6 4 4 8-8"/><path d="M15 7h6v6"/>')
  };
  /* v14: definido arriba: refresh() puede ejecutarse durante el arranque con estado restaurado (antes rompia el configurador) */
  var TIER_LABELS = { premium: 'Est\u00e1ndar', ultra: 'Ultra Premium' };
  var CZ_DEBUG = /[?&]czdebug=1/.test(location.search);
  function buildWhatsAppMessage(payload) {
    var p = payload || buildLeadPayload();
    var L = [COPY.hey, '', COPY.intro];
    var b1 = [];
    if (p.group_size) b1.push(EMOJI.people + ' Somos ' + p.group_size + ' personas');
    if (p.group_type) b1.push(COPY.group + p.group_type);
    if (p.garment_label) b1.push(COPY.garment + p.garment_label);
    if (p.tier) b1.push(COPY.tier + (p.tier === 'ultra' ? 'Ultra Premium' : 'Est\u00e1ndar'));
    if (p.design_source === 'own') {
      if (p.design_file && p.design_file_url) b1.push(COPY.designFile + ': ' + p.design_file_url);
      else if (p.design_file) b1.push(COPY.designFile + ' (' + p.design_file + ' \u2014 os lo env\u00edo en este chat)');
      if (p.design_help) b1.push(COPY.designHelp);
      if (p.logo_options) b1.push(EMOJI.sparkle + ' Logo: ' + p.logo_options.join(' + '));
      if (!p.design_file && !p.design_help) b1.push(COPY.designFile);
    } else if (p.design_reference) b1.push(isOwnIdea(p.design_reference) ? COPY.designOwn : COPY.designLiked + p.design_reference);
    if (b1.length) { L.push(''); L.push.apply(L, b1); }
    var b2 = [];
    if (p.hoodie_color) b2.push(COPY.garmentColor + (p.hoodie_color_label ? p.hoodie_color_label + ' (' + p.hoodie_color + ')' : p.hoodie_color));
    if (p.print_color) b2.push(COPY.printColor + p.print_color + (p.print_color_2 ? ' / color 2: ' + p.print_color_2 : ''));
    else if (p.print_color_2) b2.push(COPY.printColor + 'original / color 2: ' + p.print_color_2);
    if (p.custom_text) b2.push(COPY.text + p.custom_text);
    if (b2.length) { L.push(''); L.push.apply(L, b2); }
    if (p.personalizations && p.personalizations.length) {
      L.push('');
      L.push(COPY.extras);
      p.personalizations.forEach(function (x) {
        var sc = p.scopes && p.scopes[x.id];
        L.push(COPY.bullet + x.label + (sc ? ' \u2014 ' + (sc === 'partial' ? COPY.scopePartial : COPY.scopeAll) : ''));
      });
      if (p.flag) L.push(COPY.flag + p.flag);
      if (p.initials_text) L.push(EMOJI.writing + ' Iniciales: ' + p.initials_text);
      if (p.design_name) L.push(EMOJI.writing + ' Nombre en el diseño (donde pone NOMBRE): ' + p.design_name);
    } else if (p.flag) {
      L.push('');
      L.push(COPY.flag + p.flag);
    }
    if (p.destination && p.destination.zone) {
      L.push('');
      L.push(COPY.shipping + p.destination.zone + (p.destination.country ? ' \u2014 ' + p.destination.country : ''));
    }
    if (p.price_per_person != null) {
      L.push('');
      L.push(COPY.price + fmtPrice(p.price_per_person) + COPY.perPerson);
      L.push(COPY.vat);
      if (p.organizer_free) L.push('\u{1F381} Desde ' + C.organizerFreeFrom + ' personas: la del organizador va incluida (pagamos ' + (p.group_size - 1) + ')');
      L.push(p.destination && p.destination.zone && p.destination.zone !== 'Península' ? '\u{1F4E6} Envío a ' + p.destination.zone + ': costes de envío no incluidos' : '\u{1F4E6} Envío a Península incluido');
    } else if (p.garment_label && !p.garment_priced) {
      L.push('');
      L.push(COPY.pricePending);
    }
    if (p.names_design) { L.push(''); L.push('\u{1F9FE} Dise\u00f1o con la lista de nombres: ' + p.names_design.count + ' nombres' + (p.names_design.number ? ' \u00b7 n\u00famero ' + p.names_design.number : '') + (p.names_design.title ? ' \u00b7 ' + p.names_design.title : '')); L.push('(La lista completa os la paso en este chat.)'); }
    if (p.phrase) { L.push(''); L.push(EMOJI.writing + ' Frase: ' + p.phrase); }
    if (p.referred_by) { L.push(''); L.push('\u{1F91D} Vengo de parte de: ' + p.referred_by); }
    if (p.classes_in_course) { L.push(''); L.push('\u{1F3EB} Somos ' + p.classes_in_course + ' clases en el curso: quiero el precio de instituto para todas.'); }
    if (p.early_bird) { L.push(''); L.push('\u{1F4C5} ' + p.early_bird); }
    L.push('');
    L.push(COPY.closing);
    var msg = L.join('\n');
    if (CZ_DEBUG) {
      try {
        console.log('[customly] mensaje:', msg);
        console.log('[customly] code points:', Array.from ? Array.from(msg) : msg.split(''));
        console.log('[customly] encoded:', encodeURIComponent(msg));
      } catch (e) {}
    }
    return msg;
  }
  /* VERSION_CARLOS: API minima para customly-extras.js (compartir, votacion, imagenes) */
  window.CustomlyCZ = { state: function () { return state; }, save: save, shareCode: function () { return encodeShare(shareConfig()); },
    decode: decodeShare, payload: function () { return buildLeadPayload(); }, waText: function () { return buildWhatsAppMessage(); } };
  function buildWhatsAppUrl(message) {
    var num = digits(C.whatsapp);
    if (!num) return '#';
    if (message == null) message = buildWhatsAppMessage();
    return 'https://wa.me/' + num + '?text=' + encodeURIComponent(message);
  }
  /* compat: nombres antiguos usados por los CTAs existentes */
  function buildWaMessage() { return buildWhatsAppMessage(); }
  function waUrl() { return buildWhatsAppUrl(); }

  document.addEventListener('DOMContentLoaded', function () {

    /* ============================================================
       PRESUPUESTO (data-quote)
       UI: form \u2192 result | custom (persistente). LEAD: fetch en background.
    ============================================================ */
    document.querySelectorAll('[data-quote]').forEach(function (q) {
      var form = q.querySelector('form');
      var step1 = q.querySelector('[data-q-step1]');
      var result = q.querySelector('[data-q-result]');
      var custom = q.querySelector('[data-q-custom]');
      var err = q.querySelector('[data-q-error]');
      if (!form || !step1 || !result) return;

      var pref = form.querySelector('[data-q-pref]');
      var tel = form.querySelector('[data-q-tel]');
      var num = form.querySelector('[data-q-num]');
      var calcBtn = form.querySelector('[data-q-calc]');
      var canal = form.querySelector('[data-q-canal]');
      if (canal) {
        if (state.canal) canal.value = state.canal;
        canal.addEventListener('change', function () { state.canal = canal.value; save(); dl('heard_from_set', { heard_from: canal.value }); });
      }
      var statusEls = q.querySelectorAll('[data-q-lead-status]');

      form.setAttribute('novalidate', 'novalidate');
      var leadState = 'idle';
      var lastLeadKey = null;

      /* restaurar campos */
      if (tel && state.telefono) tel.value = state.telefono;
      if (pref && state.prefijo) pref.value = state.prefijo;
      if (num && state.personas) num.value = state.personas;

      form.addEventListener('focusin', function () { dl('quote_started', { location: q.id || '' }, true); });
      if (tel) tel.addEventListener('change', function () {
        state.telefono = tel.value; state.prefijo = pref ? pref.value : '+34'; save();
        if (validPhone(state.prefijo, tel.value)) dl('phone_entered', {}, true);
      });
      if (num) num.addEventListener('change', function () {
        state.personas = num.value; save();
        dl('group_size_set', { group_size: num.value });
      });

      function setLeadState(s) {
        leadState = s;
        statusEls.forEach(function (el) {
          el.hidden = s !== 'submitted';
        });
      }
      function show(el) {
        [step1, result, custom].forEach(function (x) { if (x) x.hidden = true; });
        el.hidden = false;
        el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in');
      }
      function fail(msg) { if (err) { err.textContent = msg; err.hidden = false; } }

      /* Lead en background: nunca toca la UI del presupuesto */
      function sendLeadBackground() {
        var key = JSON.stringify([state.prefijo, state.telefono, state.personas, state.prenda, (state.persos || []).join(','), state.group, state.design, state.hoodie, state.print, state.print2, state.bandera, state.fileUrl]);
        if (leadState === 'submitting') return;
        if (leadState === 'submitted' && key === lastLeadKey) return;
        var payloadField = form.querySelector('[data-q-payload]');
        if (payloadField) payloadField.value = JSON.stringify(buildLeadPayload());
        var fd = new FormData(form);
        fd.set('form_type', 'contact');
        fd.set('utf8', '\u2713');
        setLeadState('submitting');
        try {
          fetch(form.getAttribute('action') || '/contact', {
            method: 'POST', body: fd, keepalive: true, credentials: 'same-origin',
            headers: { 'Accept': 'application/json, text/html' }
          }).then(function (r) {
            if (r && (r.ok || r.status === 302 || r.type === 'opaqueredirect')) {
              lastLeadKey = key; setLeadState('submitted');
              dl('quote_lead_submitted', { group_size: state.personas || null });
            } else { setLeadState('error'); }
          }).catch(function () { setLeadState('error'); });
        } catch (e) { setLeadState('error'); }
      }

      /* C\u00e1lculo: instant\u00e1neo, local, sin submit nativo */
      function calc() {
        if (err) err.hidden = true;
        var prefV = pref ? pref.value : '+34';
        var telV = tel ? tel.value : '';
        var n = num ? parseInt(num.value, 10) : NaN;

        if (!validPhone(prefV, telV)) { fail('Revisa el tel\u00e9fono: para +34 son 9 cifras.'); return; }
        if (!isFinite(n) || n < 1) {
          /* v14.2: en el configurador el numero se pide en el paso 6 -> se lleva al usuario alli */
          var czSize = q.closest('[data-configurator]') && q.closest('[data-configurator]').querySelector('[data-cz-groupsize]');
          if (czSize) {
            fail('Indica cu\u00e1ntas personas sois en el paso 6 \u00ab\u00bfCu\u00e1ntos sois?\u00bb (m\u00ednimo ' + MIN + ').');
            var st6 = czSize.closest('.cz-step'); if (st6) { st6.classList.add('is-open'); st6.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
            setTimeout(function () { try { czSize.focus({ preventScroll: true }); czSize.select(); } catch (e) {} }, 350);
          } else fail('Dinos cu\u00e1ntas personas sois.');
          return;
        }

        state.prefijo = prefV; state.telefono = telV; state.personas = String(n);
        state.source = state.source || q.id || 'quote'; save();

        if (n < MIN) {
          /* VERSION_CARLOS: de 1 a 4 prendas (reposiciones, alguien que se suma tarde) -> salida por WhatsApp, no un error */
          if (custom) {
            var cmS = custom.querySelector('[data-q-custom-msg]');
            if (cmS) cmS.textContent = 'Los pedidos de grupo empiezan en ' + MIN + ' personas. Si sois ' + n + ' (una reposición, alguien que se suma tarde o una prenda suelta de un diseño ya hecho), escríbenos y te creamos un enlace de pago individual.';
            custom.querySelectorAll('[data-q-wa]').forEach(function (a) { a.href = waUrl(); });
            show(custom);
            sendLeadBackground();
          } else fail((C.minMsg || 'Trabajamos a partir de {min} prendas.').replace('{min}', MIN));
          dl('quote_out_of_range', { group_size: n, reason: 'below_min' });
          return;
        }

        var g = currentGarment();
        var tierGate = state.tier === 'ultra';
        function showCustom(msg, reason) {
          if (custom) {
            var cm = custom.querySelector('[data-q-custom-msg]');
            if (cm && msg) cm.textContent = msg;
            custom.querySelectorAll('[data-q-wa]').forEach(function (a) { a.href = waUrl(); });
            show(custom);
          } else {
            fail(msg || C.fueraRango || 'Os preparamos un presupuesto personalizado. Escr\u00edbenos por WhatsApp.');
          }
          dl('quote_out_of_range', { group_size: n, reason: reason, garment: g.id });
          sendLeadBackground();
        }

        if (tierGate && g.tiers && n < g.tiers[0].min) {
          showCustom('La gama Ultra Premium empieza en ' + g.tiers[0].min + ' prendas. Con ' + n + ' personas podéis elegir la gama Estándar (desde ' + MIN + ') o te preparamos una propuesta por WhatsApp.', 'ultra_below_min');
          return;
        }
        if (tierGate && !g.tiers) {
          showCustom(C.ultraMsg || 'Esta prenda en Ultra Premium lleva presupuesto personalizado: os lo preparamos por WhatsApp.', 'ultra_tier_pending');
          return;
        }
        if (!g.tiers) {
          showCustom(C.pendienteMsg || 'Esta prenda a\u00fan no tiene tarifa online: os preparamos un presupuesto personalizado por WhatsApp.', 'garment_pending');
          return;
        }

        var tier = findTier(n);
        if (!tier) { showCustom(C.fueraRango, 'above_max'); return; }

        var sup = surchargeTotal();
        var unit = Math.round((tier.price + sup) * 100) / 100;
        if (earlyBirdActive()) unit = Math.round(unit * (1 - C.earlyBird.pct / 100) * 100) / 100;
        var priceEl = result.querySelector('[data-q-price]');
        var groupEl = result.querySelector('[data-q-group]');
        var detailEl = result.querySelector('[data-q-detail]');
        if (priceEl) priceEl.textContent = fmtPrice(unit);
        /* VERSION_CARLOS: el envío solo va incluido a Península; para el resto se avisa en el precio */
        var shipEl = result.querySelector('[data-q-ship]'), shipLi = result.querySelector('[data-q-ship-bullet]');
        var fuera = state.destino && state.destino !== 'Península';
        if (shipEl) { shipEl.textContent = fuera ? (state.destino === 'Internacional' ? (state.pais ? 'Envío a ' + state.pais : 'Envío internacional') : 'Envío a ' + state.destino) + ': los costes de envío no están incluidos en este precio. Te los confirmamos en el presupuesto.' : 'Envío a Península incluido.'; shipEl.classList.toggle('is-warn', !!fuera); shipEl.hidden = false; }
        if (shipLi) shipLi.hidden = !!fuera;
        var orgFree = C.organizerFreeFrom && n >= C.organizerFreeFrom;
        if (groupEl) groupEl.textContent = 'para vuestro grupo de ' + n + ' personas' + (orgFree ? ' \u00b7 la de quien organiza va incluida: pag\u00e1is ' + (n - 1) + ' (total ' + fmtPrice(Math.round(unit * (n - 1) * 100) / 100) + ')' : '');
        if (detailEl) {
          var parts = [g.label];
          if (sup > 0) parts.push('incluye +' + fmtPrice(sup) + '/persona de personalizaciones');
          detailEl.textContent = parts.join(' \u00b7 ');
          detailEl.hidden = false;
        }
        var nextEl = result.querySelector('[data-q-next]');
        if (nextEl) {
          var vol = getPricingForQuantity(n, g.tiers);
          if (vol.nextThreshold != null) {
            var nUnit = Math.round((vol.nextPrice + sup) * 100) / 100;
            nextEl.innerHTML = ICON.trend + ' '; nextEl.appendChild(document.createTextNode(vol.peopleNeeded === 1
              ? 'Con solo 1 persona m\u00e1s: ' + fmtPrice(nUnit) + '/persona. Ahorr\u00e1is ' + fmtPrice(vol.savingPerPerson) + ' por prenda.'
              : 'Si lleg\u00e1is a ' + vol.nextThreshold + ': ' + fmtPrice(nUnit) + '/persona. Ahorr\u00e1is ' + fmtPrice(vol.savingPerPerson) + ' por prenda.'));
            nextEl.hidden = false;
          } else {
            nextEl.textContent = 'Ya ten\u00e9is nuestro mejor precio por volumen.';
            nextEl.hidden = false;
          }
          if (!orgFree && C.organizerFreeFrom && n < C.organizerFreeFrom) {
            var orgHint = document.createElement('span');
            orgHint.className = 'q-org';
            orgHint.textContent = ' Desde ' + C.organizerFreeFrom + ' personas, la prenda de quien organiza va incluida.';
            nextEl.appendChild(orgHint);
          }
        }
        /* VERSION_CARLOS: sumad otra clase o grupo para bajar de tramo */
        var mergeEl = result.querySelector('[data-q-merge]');
        if (!mergeEl && nextEl) {
          mergeEl = document.createElement('div'); mergeEl.className = 'q-merge'; mergeEl.setAttribute('data-q-merge', '');
          mergeEl.innerHTML = '<button type="button" class="q-merge__btn" data-q-merge-open>\u00bfCu\u00e1ntas clases sois en vuestro curso? Ver el precio de instituto</button>' +
            '<div class="q-merge__box" hidden><label>Clases en vuestro curso, contando la tuya<input type="number" min="1" max="12" step="1" inputmode="numeric" placeholder="Ej. 4" data-q-merge-n></label><p class="q-merge__out" aria-live="polite" data-q-merge-out></p></div>';
          nextEl.parentNode.insertBefore(mergeEl, nextEl.nextSibling);
          mergeEl.querySelector('[data-q-merge-open]').addEventListener('click', function () { var bx = mergeEl.querySelector('.q-merge__box'); bx.hidden = !bx.hidden; if (!bx.hidden) mergeEl.querySelector('input').focus(); });
        }
        if (mergeEl) {
          var mIn = mergeEl.querySelector('[data-q-merge-n]'), mOut = mergeEl.querySelector('[data-q-merge-out]');
          mIn.oninput = function () {
            var k = parseInt(mIn.value, 10); if (!isFinite(k) || k < 1) { mOut.textContent = ''; state.clasesCurso = null; save(); return; }
            k = Math.min(k, 12); state.clasesCurso = k; save();
            if (k < 2) { mOut.textContent = 'Si se suma otra clase de vuestro centro, el precio baja para las dos.'; return; }
            var tot = n * k, tj = findTier(tot);
            if (!tj) { mOut.textContent = 'Todo el curso (unas ' + tot + ' prendas): os preparamos un presupuesto personalizado.'; return; }
            var u2 = Math.round((tj.price + sup) * 100) / 100, ahorro = Math.round((unit - u2) * 100) / 100;
            mOut.innerHTML = 'Todo el curso junto (' + k + ' clases, unas ' + tot + ' prendas): <strong>' + fmtPrice(u2) + '/persona</strong>' + (ahorro > 0 ? ', ' + fmtPrice(ahorro) + ' menos cada uno.' : ' (mismo tramo).') + ' Cada clase paga con su enlace y todas suman para el precio. <a href="/pages/modo-instituto" target="_blank" rel="noopener">Cómo funciona el modo instituto</a>';
            dl('quote_merge_groups', { group_size: n, classes: k });
          };
          if (!mIn.value && state.clasesCurso) mIn.value = state.clasesCurso;
          if (mIn.value) mIn.oninput();
        }
        result.querySelectorAll('[data-q-wa]').forEach(function (a) { a.href = waUrl(); });
        show(result);
        dl('quote_calculated', { group_size: n, garment: g.id, price_base: tier.price, surcharge_total: sup, price_per_person: unit, price_total: Math.round(unit * n * 100) / 100 });
        sendLeadBackground();
      }

      /* Disparadores: bot\u00f3n (type=button), Enter en los campos, y cualquier submit queda anulado.
         As\u00ed ning\u00fan script externo (captcha de Shopify, apps) puede provocar la navegaci\u00f3n nativa. */
      if (calcBtn) calcBtn.addEventListener('click', calc);
      [tel, num].forEach(function (inp) {
        if (!inp) return;
        inp.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); calc(); }
        });
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); calc(); });

      q.querySelectorAll('[data-q-back]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); show(step1); });
      });

      q.querySelectorAll('[data-q-wa]').forEach(function (a) {
        a.addEventListener('click', function () {
          a.href = waUrl();
          sendLeadBackground();
          dl('whatsapp_clicked', { location: q.id || '' });
          trackLead('whatsapp', q.id || '');
          /* v14.2: pagina de gracias (WhatsApp se abre en otra pestaña/app y esta pestaña muestra los siguientes pasos) */
          if (C.thanksUrl) setTimeout(function () { window.location.href = C.thanksUrl + '?via=whatsapp'; }, 900);
        });
      });
    });

    /* Botones de WhatsApp gen\u00e9ricos (burbuja, CTAs) \u2014 tracking sin duplicar */
    document.querySelectorAll('a[href^="https://wa.me"]').forEach(function (a) {
      if (a.hasAttribute('data-q-wa')) return;
      a.addEventListener('click', function () { dl('whatsapp_clicked', { location: 'generic' }); trackLead('whatsapp_directo', 'generic'); });
    });

    /* ============================================================
       CONFIGURADOR (data-configurator)
    ============================================================ */
    document.querySelectorAll('[data-configurator]').forEach(function (cz) {
      dl('configurator_started', {}, true);
      var frame = cz.querySelector('[data-cz-frame]');
      var pvName = cz.querySelector('[data-pv-name]');
      var chips = cz.querySelector('[data-pv-chips]');
      var hint = cz.querySelector('[data-pv-contrast]');
      var dthumb = cz.querySelector('[data-pv-design]');

      /* ---------- PVEngine v6: mockups reales + tinte realista + giro espalda/delantera ---------- */
      var stage = cz.querySelector('[data-pv-stage]');
      var rotateBtn = cz.querySelector('[data-pv-rotate]');
      var rotateLabel = cz.querySelector('[data-pv-rotate-label]');
      var viewtag = cz.querySelector('[data-pv-viewtag]');
      var pvText = cz.querySelector('[data-pv-text]');
      var canvases = {};
      ['back', 'front'].forEach(function (v) {
        var el = cz.querySelector('[data-pv-canvas="' + v + '"]');
        if (el) canvases[v] = el;
      });
      var MOCKS = C.mockups || {};
      var ZONES = C.designZones || {};
      var pvCache = {};
      var pvActive = null;
      var pvRaf = false;
      var pvLast = '';

      function loadImg(src2) {
        return new Promise(function (res) {
          if (!src2) return res(null);
          var im = new Image();
          im.crossOrigin = 'anonymous';
          im.onload = function () { res(im); };
          im.onerror = function () {
            var im2 = new Image();
            im2.onload = function () { res(im2); };
            im2.onerror = function () { res(null); };
            im2.src = src2;
          };
          im.src = src2;
        });
      }
      /* ---------- PVEngine v14: tinte por pixel en espacio lineal ----------
         1) De la foto del mockup blanco se extrae un mapa de sombreado s = L / L_ref (pliegues y volumen).
         2) La mascara segmentada (assets customly-mask-*.png) recorta la silueta con borde suave.
         3) Color final = color_lineal * sombreado (+ brillo suave), recortado por la mascara.
         4) Los herrajes (cremalleras) se restauran desde la foto original.
         5) El diseno estandar (PNG blanco #FFFFFF / gris #B2B2B2) se recolorea y sigue los pliegues. */
      var LIN = new Float32Array(256);
      for (var li = 0; li < 256; li++) { var cv0 = li / 255; LIN[li] = cv0 <= 0.04045 ? cv0 / 12.92 : Math.pow((cv0 + 0.055) / 1.055, 2.4); }
      var SRGB = new Uint8ClampedArray(4096);
      for (var si = 0; si < 4096; si++) { var x0 = si / 4095; SRGB[si] = Math.round(255 * (x0 <= 0.0031308 ? x0 * 12.92 : 1.055 * Math.pow(x0, 1 / 2.4) - 0.055)); }
      function toSrgb(v) { return SRGB[v <= 0 ? 0 : v >= 1 ? 4095 : (v * 4095) | 0]; }
      function linRgb(hex) { var c = hexToRgb(hex) || { r: 255, g: 255, b: 255 }; return [LIN[c.r], LIN[c.g], LIN[c.b]]; }

      function pixelsOf(img, W, H) {
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, W, H);
        return x.getImageData(0, 0, W, H).data;
      }
      function prepView(mock, mask, hw, print) {
        if (!mock) return null;
        var W = mock.naturalWidth || 1000, H = mock.naturalHeight || 1400, N = W * H;
        var px, mk, hwp = null, prp = null;
        try { px = pixelsOf(mock, W, H); mk = mask ? pixelsOf(mask, W, H) : null; if (hw) hwp = pixelsOf(hw, W, H); if (print) prp = pixelsOf(print, W, H); }
        catch (e) { return { W: W, H: H, tainted: true, mock: mock }; }
        /* v14.1: zona imprimible (R) y cuerpo (G) — el estampado se recorta con R; las mangas son prenda - G */
        var pm = null, bd = null;
        if (prp) {
          pm = new Uint8Array(N); bd = new Uint8Array(N);
          for (var q = 0, qq = 0; q < N; q++, qq += 4) { pm[q] = prp[qq]; bd[q] = prp[qq + 1]; }
        }
        var shade = new Float32Array(N), alpha = new Uint8Array(N), hwa = hwp ? new Uint8Array(N) : null;
        var hist = new Uint32Array(1024), cnt = 0, i, p;
        for (i = 0, p = 0; i < N; i++, p += 4) {
          var L = 0.2126 * LIN[px[p]] + 0.7152 * LIN[px[p + 1]] + 0.0722 * LIN[px[p + 2]];
          shade[i] = L;
          var a = mk ? Math.max(mk[p + 3] < 255 ? mk[p + 3] : 0, mk[p]) : 255; /* mascara L (blanco=prenda) o con alfa */
          alpha[i] = a;
          if (a > 250) { hist[Math.min(1023, (L * 1023) | 0)]++; cnt++; }
          if (hwa) hwa[i] = hwp[p + 3] > 0 ? hwp[p + 3] : 0;
        }
        /* referencia = percentil 96 de la luminancia dentro de la prenda */
        var target = cnt * 0.96, acc = 0, ref = 0.9;
        for (i = 0; i < 1024; i++) { acc += hist[i]; if (acc >= target) { ref = i / 1023; break; } }
        for (i = 0; i < N; i++) shade[i] = shade[i] / ref;
        return { W: W, H: H, shade: shade, alpha: alpha, hw: hwa, px: hwa ? px : null, pm: pm, bd: bd };
      }
      function loadGarment(id, cb) {
        var m = MOCKS[id];
        if (!m || !window.Promise || !canvases.back) { if (cb) cb(null); return; }
        if (pvCache[id]) {
          if (pvCache[id].ready) { if (cb) cb(pvCache[id]); }
          else if (cb) pvCache[id].cbs.push(cb);
          return;
        }
        var entry = { ready: false, cbs: cb ? [cb] : [] };
        pvCache[id] = entry;
        var pz = (C.printZones || {})[id] || {};
        Promise.all([m.back, m.front, m.maskBack, m.maskFront, m.hwBack, m.hwFront, pz.mask, pz.bodyFront].map(loadImg)).then(function (r) {
          /* v14.3: la delantera tambien tiene mascara de cuerpo (canal G) -> la bandera se recorta a la manga */
          entry.views = { back: prepView(r[0], r[2], r[4], r[6]), front: prepView(r[1], r[3], r[5], r[7]) };
          entry.ready = true;
          entry.cbs.forEach(function (f) { if (f) f(entry); });
          entry.cbs = [];
        });
      }

      /* diseno estandar: se carga una vez y se guarda su canal de intensidad (blanco=1, gris #B2B2B2=0.7) */
      var designCache = {};
      function loadDesign(url, cb) {
        if (!url) return cb(null);
        if (designCache[url]) { if (designCache[url].ready) return cb(designCache[url]); designCache[url].cbs.push(cb); return; }
        var d = designCache[url] = { ready: false, cbs: [cb] };
        loadImg(url).then(function (img) {
          if (img) {
            var W = img.naturalWidth, H = img.naturalHeight;
            try {
              var p = pixelsOf(img, W, H), N = W * H, v = new Uint8Array(N), a = new Uint8Array(N), nOp = 0, nSec = 0;
              for (var i = 0, q = 0; i < N; i++, q += 4) {
                v[i] = p[q]; a[i] = p[q + 3];
                if (a[i] > 230) { nOp++; if (v[i] > 140 && v[i] < 215) nSec++; }
              }
              d.W = W; d.H = H; d.v = v; d.a = a;
              /* v14.1: slots de color — primario = #FFFFFF, secundario = #B2B2B2 (solo si la plantilla lo contiene) */
              d.hasSecondary = nSec > Math.max(150, nOp * 0.004);
            } catch (e) { d.img = img; }
          }
          d.ready = true;
          d.cbs.forEach(function (f) { f(d); }); d.cbs = [];
        });
      }

      function renderView(view) {
        var entry = pvCache[pvActive];
        var cv = canvases[view];
        if (!entry || !entry.ready || !cv) return;
        var V = entry.views[view];
        if (!V) return;
        if (cv.width !== V.W || cv.height !== V.H) { cv.width = V.W; cv.height = V.H; }
        var ctx = cv.getContext('2d');
        if (!ctx) return;
        ctx.clearRect(0, 0, V.W, V.H);
        if (V.tainted) { ctx.drawImage(V.mock, 0, 0, V.W, V.H); return; }
        lastPrintBottom = 0;
        var c = linRgb(state.hoodie || '#FFFFFF');
        var lumc = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
        var k = 1 + 0.9 * (1 - Math.min(1, lumc * 4));        /* mas contraste de pliegue en oscuros */
        var hiK = 0.18 + 0.22 * (1 - lumc), amb = (1 - lumc) * 0.012;
        var N = V.W * V.H, out = ctx.createImageData(V.W, V.H), o = out.data, s, sh, hi, r, g, b, i, p;
        var shBuf = new Float32Array(N);
        for (i = 0, p = 0; i < N; i++, p += 4) {
          var a = V.alpha[i];
          if (!a) continue;
          s = V.shade[i];
          sh = 1 - (1 - (s < 1 ? s : 1)) * k; if (sh < 0.05) sh = 0.05;
          shBuf[i] = sh;
          hi = s > 1 ? (s - 1 > 0.25 ? 0.25 : s - 1) * hiK : 0;
          var am = amb * sh * sh * sh;
          r = c[0] * sh + hi + am; g = c[1] * sh + hi + am; b = c[2] * sh + hi + am;
          if (V.hw && V.hw[i]) { /* herraje: mezcla con la foto original */
            var t = V.hw[i] / 255;
            o[p] = toSrgb(r) * (1 - t) + V.px[p] * t; o[p + 1] = toSrgb(g) * (1 - t) + V.px[p + 1] * t; o[p + 2] = toSrgb(b) * (1 - t) + V.px[p + 2] * t;
          } else { o[p] = toSrgb(r); o[p + 1] = toSrgb(g); o[p + 2] = toSrgb(b); }
          o[p + 3] = a;
        }
        if (view === 'back' && state.designOverlay && state.dsrc !== 'names') {
          var d = designCache[state.designOverlay];
          if (d && d.ready && d.v) paintDesign(o, V, shBuf, d);
        }
        if (view === 'back' && state.dsrc === 'own' && ownLogo) paintLogo(o, V, shBuf, ownLogo);
        if (view === 'back' && state.dsrc === 'names') paintNames(o, V, shBuf);
        paintExtras(o, V, shBuf, view);
        paintFlag(o, V, shBuf, view);
        ctx.putImageData(out, 0, 0);
      }

      /* ---------- v14.1: bandera estampada en la manga ----------
         Se pinta dentro del lienzo (no como imagen superpuesta): proyeccion cilindrica sobre el brazo (curvatura),
         rotacion/sesgo de la config sleeves, sombreado del tejido y recorte por la silueta de la manga. */
      var flagCache = {};
      function loadFlag(name) {
        if (flagCache[name]) return;
        var fc = flagCache[name] = { ready: false };
        loadImg(FLAGS[name]).then(function (img) {
          if (img) {
            try {
              var W = img.naturalWidth, H = img.naturalHeight, p = pixelsOf(img, W, H), N = W * H;
              var lin = new Float32Array(N * 3), a = new Uint8Array(N);
              for (var i = 0, q = 0; i < N; i++, q += 4) { lin[i * 3] = LIN[p[q]]; lin[i * 3 + 1] = LIN[p[q + 1]]; lin[i * 3 + 2] = LIN[p[q + 2]]; a[i] = p[q + 3]; }
              fc.W = W; fc.H = H; fc.lin = lin; fc.a = a;
            } catch (e) {}
          }
          fc.ready = true;
          requestRender(true);
        });
      }
      function paintFlag(o, V, shBuf, view) {
        var name = flagKey();
        if (!name || !FLAGS[name]) return;
        var fc = flagCache[name];
        if (!fc) { loadFlag(name); return; }
        if (!fc.ready || !fc.lin) return;
        var pF = sleevePoint(view, 'left');
        if (!pF) return;
        var W = V.W, H = V.H, cx = pF.x * W, cy = pF.y * H;
        var fw = (pF.w || 0.068) * W, fh = fw * fc.H / fc.W, hw = fw / 2, hh = fh / 2;
        var rot = (pF.rot || 0) * Math.PI / 180, cs = Math.cos(rot), sn = Math.sin(rot);
        var skew = pF.skew || 0, mt = (pF.curve != null ? pF.curve : 0.42) * Math.PI / 2, smt = Math.sin(mt);
        var R = Math.ceil(Math.sqrt(fw * fw + fh * fh) / 2) + 2;
        var x0 = Math.max(0, Math.floor(cx - R)), x1 = Math.min(W - 1, Math.ceil(cx + R));
        var y0 = Math.max(0, Math.floor(cy - R)), y1 = Math.min(H - 1, Math.ceil(cy + R));
        for (var y = y0; y <= y1; y++) {
          for (var x = x0; x <= x1; x++) {
            var i = y * W + x;
            var ga = V.alpha[i]; if (!ga) continue;
            /* solo sobre manga: en espalda se descarta el cuerpo (canal G de la mascara imprimible) */
            var sa = V.bd ? ga * (255 - V.bd[i]) / 255 : ga; if (sa < 2) continue;
            var dx = x + 0.5 - cx, dy = y + 0.5 - cy;
            var lx = dx * cs + dy * sn, ly = -dx * sn + dy * cs;
            ly -= lx * skew;
            if (lx <= -hw || lx >= hw || ly <= -hh || ly >= hh) continue;
            /* cilindro: el centro se ve de frente y los bordes se comprimen al girar el brazo */
            var u = lx / hw, th = Math.asin(Math.max(-1, Math.min(1, u * smt))), s = th / mt;
            ly += (1 - Math.cos(th)) * fh * 0.08;           /* ligera curvatura de las franjas */
            var tx = ((s + 1) / 2) * (fc.W - 1), ty = (ly / fh + 0.5) * (fc.H - 1);
            if (ty < 0 || ty > fc.H - 1) continue;
            /* muestreo bilineal (sin pixelado al escalar la bandera) */
            var ix = tx | 0, iy = ty | 0, fx = tx - ix, fy = ty - iy;
            var ix1 = ix + 1 < fc.W ? ix + 1 : ix, iy1 = iy + 1 < fc.H ? iy + 1 : iy;
            var t00 = iy * fc.W + ix, t10 = iy * fc.W + ix1, t01 = iy1 * fc.W + ix, t11 = iy1 * fc.W + ix1;
            var w00 = (1 - fx) * (1 - fy), w10 = fx * (1 - fy), w01 = (1 - fx) * fy, w11 = fx * fy;
            var fa = fc.a[t00] * w00 + fc.a[t10] * w10 + fc.a[t01] * w01 + fc.a[t11] * w11; if (fa < 1) continue;
            var L = fc.lin;
            var fr = L[t00 * 3] * w00 + L[t10 * 3] * w10 + L[t01 * 3] * w01 + L[t11 * 3] * w11;
            var fg = L[t00 * 3 + 1] * w00 + L[t10 * 3 + 1] * w10 + L[t01 * 3 + 1] * w01 + L[t11 * 3 + 1] * w11;
            var fb = L[t00 * 3 + 2] * w00 + L[t10 * 3 + 2] * w10 + L[t01 * 3 + 2] * w01 + L[t11 * 3 + 2] * w11;
            var edge = Math.min(1, hw - Math.abs(lx), hh - Math.abs(ly));   /* antialias del borde */
            /* tinta sobre tejido: sigue los pliegues y la textura del mockup y gira con el brazo */
            var tex = V.shade[i]; tex = tex > 1.12 ? 1.12 : tex;
            var light = (0.78 + 0.22 * Math.cos(th)) * (0.62 + 0.38 * shBuf[i]) * (0.86 + 0.14 * tex);
            var al = (fa / 255) * (sa / 255) * edge * 0.92, p = i * 4;
            o[p] = o[p] * (1 - al) + toSrgb(fr * light) * al;
            o[p + 1] = o[p + 1] * (1 - al) + toSrgb(fg * light) * al;
            o[p + 2] = o[p + 2] * (1 - al) + toSrgb(fb * light) * al;
          }
        }
      }
      function paintDesign(o, V, shBuf, d) {
        var z = PRINT[pvActive] || PRINT.hoodie;
        /* VERSION_CARLOS: en hoodie y zipper la plantilla arranca algo mas abajo para que la capucha no tape la primera linea */
        var hoodPad = (pvActive === 'hoodie' || pvActive === 'zipper') ? 0.04 * V.H : 0;
        var nameRes = ((state.persos || []).indexOf('nombre') > -1 && state.nombrePrueba) ? 0.075 * V.H : 0;   /* hueco para el nombre de prueba */
        var scale = Math.min((z.w * V.W) / d.W, (z.h * V.H - hoodPad - nameRes) / d.H);
        var dw = Math.round(d.W * scale), dh = Math.round(d.H * scale);
        var x0 = Math.round(z.cx * V.W - dw / 2), y0 = Math.round(z.top * V.H + hoodPad + Math.max(0, z.h * V.H - hoodPad - nameRes - dh) * 0.25);
        /* v14.1: dos slots independientes. Fuente #FFFFFF -> color 1 (state.print); fuente #B2B2B2 -> color 2 (state.print2).
           Por defecto cada slot conserva su color original. Los pixeles intermedios (antialias entre ambos) se interpolan. */
        var c1 = linRgb(state.print || DESIGN_SRC[0]), c2 = linRgb(state.print2 || DESIGN_SRC[1]);
        var inv = 1 / scale, PM = V.pm;
        for (var y = 0; y < dh; y++) {
          var Y = y0 + y; if (Y < 0 || Y >= V.H) continue;
          var sy = Math.min(d.H - 1, (y * inv) | 0);
          for (var x = 0; x < dw; x++) {
            var X = x0 + x; if (X < 0 || X >= V.W) continue;
            var si2 = sy * d.W + Math.min(d.W - 1, (x * inv) | 0);
            var da = d.a[si2]; if (!da) continue;
            var i = Y * V.W + X;
            /* recorte por zona imprimible: la capucha, el cuello y las mangas quedan por encima del estampado */
            var clip = PM ? PM[i] : V.alpha[i]; if (!clip) continue;
            var f = (d.v[si2] - 178) / 77; f = f < 0 ? 0 : f > 1 ? 1 : f;   /* 1 = slot primario, 0 = slot secundario */
            var sh = 0.82 + 0.18 * shBuf[i];                 /* la tinta sigue los pliegues */
            var al = (da / 255) * (clip / 255) * 0.96, p = i * 4;
            var r = (c2[0] + (c1[0] - c2[0]) * f) * sh, g = (c2[1] + (c1[1] - c2[1]) * f) * sh, b = (c2[2] + (c1[2] - c2[2]) * f) * sh;
            o[p] = o[p] * (1 - al) + toSrgb(r) * al;
            o[p + 1] = o[p + 1] * (1 - al) + toSrgb(g) * al;
            o[p + 2] = o[p + 2] * (1 - al) + toSrgb(b) * al;
          }
        }
        lastPrintBottom = y0 + dh;
      }
      /* ---------- VERSION_CARLOS: logo propio en la vista previa ----------
         El archivo del cliente (PNG/JPG/SVG) se pinta en la espalda siguiendo los pliegues.
         Opciones: quitar el fondo (color de las esquinas) y pasar a un solo color (el del paso 4). */
      var ownLogo = null, ownVer = 0, ownImg = null;
      state.logoOpts = state.logoOpts || { bg: false, mono: false };
      function buildOwnLogo() {
        if (!ownImg) { ownLogo = null; return; }
        var W0 = ownImg.naturalWidth || 800, H0 = ownImg.naturalHeight || 800, k = Math.min(1, 900 / Math.max(W0, H0));
        var W = Math.max(1, Math.round(W0 * k)), H = Math.max(1, Math.round(H0 * k));
        var p;
        try { p = pixelsOf(ownImg, W, H); } catch (e) { ownLogo = null; return; }
        var N = W * H, a = new Uint8Array(N), lin = new Float32Array(N * 3);
        var bgR = 0, bgG = 0, bgB = 0, nb = 0;
        if (state.logoOpts.bg) {
          [[0, 0], [W - 1, 0], [0, H - 1], [W - 1, H - 1]].forEach(function (c) {
            for (var dy = 0; dy < 4; dy++) for (var dx = 0; dx < 4; dx++) {
              var x = Math.min(W - 1, Math.max(0, c[0] + (c[0] ? -dx : dx))), y = Math.min(H - 1, Math.max(0, c[1] + (c[1] ? -dy : dy)));
              var q = (y * W + x) * 4; if (p[q + 3] > 200) { bgR += p[q]; bgG += p[q + 1]; bgB += p[q + 2]; nb++; }
            }
          });
          if (nb) { bgR /= nb; bgG /= nb; bgB /= nb; }
        }
        var minX = W, minY = H, maxX = -1, maxY = -1;
        for (var i = 0, q = 0; i < N; i++, q += 4) {
          var al = p[q + 3];
          if (al && nb) {
            var dr = p[q] - bgR, dg = p[q + 1] - bgG, db = p[q + 2] - bgB, dist = Math.sqrt(dr * dr + dg * dg + db * db);
            al = dist < 38 ? 0 : dist < 70 ? al * (dist - 38) / 32 : al;
          }
          a[i] = al; lin[i * 3] = LIN[p[q]]; lin[i * 3 + 1] = LIN[p[q + 1]]; lin[i * 3 + 2] = LIN[p[q + 2]];
          if (al > 16) { var x2 = i % W, y2 = (i / W) | 0; if (x2 < minX) minX = x2; if (x2 > maxX) maxX = x2; if (y2 < minY) minY = y2; if (y2 > maxY) maxY = y2; }
        }
        if (maxX < 0) { ownLogo = null; return; }
        ownLogo = { W: W, H: H, a: a, lin: lin, bx: minX, by: minY, bw: maxX - minX + 1, bh: maxY - minY + 1 };
      }
      function paintLogo(o, V, shBuf, d) {
        var z = PRINT[pvActive] || PRINT.hoodie;
        var scale = Math.min((z.w * V.W) / d.bw, (z.h * V.H) / d.bh) * 0.82;
        var dw = Math.round(d.bw * scale), dh = Math.round(d.bh * scale);
        var x0 = Math.round(z.cx * V.W - dw / 2), y0 = Math.round(z.top * V.H + (z.h * V.H - dh) * 0.35);
        lastPrintBottom = y0 + dh;
        var gc = linRgb(state.hoodie || '#FFFFFF'), glum = 0.2126 * gc[0] + 0.7152 * gc[1] + 0.0722 * gc[2];
        var mono = state.logoOpts.mono, mc = linRgb(state.print || (glum > 0.35 ? '#234056' : '#FFFFFF')), inv = 1 / scale, PM = V.pm;
        for (var y = 0; y < dh; y++) {
          var Y = y0 + y; if (Y < 0 || Y >= V.H) continue;
          var sy = d.by + Math.min(d.bh - 1, (y * inv) | 0);
          for (var x = 0; x < dw; x++) {
            var X = x0 + x; if (X < 0 || X >= V.W) continue;
            var si = sy * d.W + d.bx + Math.min(d.bw - 1, (x * inv) | 0), da = d.a[si]; if (!da) continue;
            var i = Y * V.W + X, clip = PM ? PM[i] : V.alpha[i]; if (!clip) continue;
            var sh = 0.82 + 0.18 * shBuf[i], al = (da / 255) * (clip / 255) * 0.96, pp = i * 4;
            var r = mono ? mc[0] : d.lin[si * 3], g = mono ? mc[1] : d.lin[si * 3 + 1], b = mono ? mc[2] : d.lin[si * 3 + 2];
            o[pp] = o[pp] * (1 - al) + toSrgb(r * sh) * al;
            o[pp + 1] = o[pp + 1] * (1 - al) + toSrgb(g * sh) * al;
            o[pp + 2] = o[pp + 2] * (1 - al) + toSrgb(b * sh) * al;
          }
        }
      }
      /* ---------- VERSION_CARLOS: diseño «Con los nombres de la clase» ----------
         Número grande de la promoción formado por todos los nombres (estilo leavers británico) o bloque de nombres. */
      var namesCache = { key: null, bmp: null };
      /* cuando llega la fuente Anton se rehace el número (la primera vez puede pintarse con la de reserva) */
      if (document.fonts && document.fonts.load) document.fonts.load('400 80px Anton').then(function () { namesCache.key = null; if (state.dsrc === 'names' && typeof requestRender === 'function') requestRender(true); }).catch(function () {});
      function namesList() {
        return String(state.namesText || '').split(/[\n,;]+/).map(function (s) { return s.trim().replace(/\s+/g, ' '); }).filter(Boolean).slice(0, 160);
      }
      function inkHex() { return state.print || (luminance(state.hoodie || '#FFFFFF') > 0.35 ? '#234056' : '#FFFFFF'); }
      function ink2Hex() { return state.print2 || (luminance(state.hoodie || '#FFFFFF') > 0.35 ? '#8A97A3' : '#B2B2B2'); }
      function namesBitmap() {
        var list = namesList(); if (!list.length) return null;
        var big = String(state.namesBig || '').trim().slice(0, 4), title = String(state.namesTitle || '').trim().toUpperCase().slice(0, 28);
        var foot = String(state.namesFoot || '').trim().toUpperCase().slice(0, 32);
        var style = state.namesStyle === 'bloque' ? 'bloque' : 'numero';
        var c1 = inkHex(), c2 = ink2Hex();
        var key = JSON.stringify([list, big, title, foot, style, c1, c2]);
        if (namesCache.key === key) return namesCache.bmp;
        var fam = (getComputedStyle(document.body).fontFamily || 'sans-serif');
        var W = 1000, mc = document.createElement('canvas').getContext('2d');
        var names = list.map(function (n) { return n.toUpperCase(); });
        /* cada bloque (título, número, texto de abajo) reserva su propia altura: así ninguno tapa ni expulsa al otro */
        var parts = [], fit = true;
        if (title) {
          var ts = 92; mc.font = '800 ' + ts + 'px ' + fam; while (mc.measureText(title).width > 920 && ts > 40) { ts -= 4; mc.font = '800 ' + ts + 'px ' + fam; }
          parts.push({ h: Math.round(ts * 1.3) + 22, draw: function (x, y0) { x.textAlign = 'center'; x.fillStyle = c1; x.font = '800 ' + ts + 'px ' + fam; x.fillText(title, W / 2, y0 + ts); } });
        }
        if (style === 'numero' && big) {
          /* 1) silueta del número */
          /* el número va en la condensada gruesa del flyer (Anton): más superficie para los nombres */
          var famNum = (document.fonts && document.fonts.check && document.fonts.check('400 80px Anton')) ? 'Anton, ' + fam : fam, wNum = famNum === fam ? '900 ' : '400 ';
          var bs = famNum === fam ? 760 : 900; mc.font = wNum + bs + 'px ' + famNum; while (mc.measureText(big).width > 940 && bs > 200) { bs -= 20; mc.font = wNum + bs + 'px ' + famNum; }
          var GH = Math.ceil(bs * 1.05), base = Math.round(bs * 0.95);
          var nc = document.createElement('canvas'); nc.width = W; nc.height = GH; var nx = nc.getContext('2d');
          nx.font = wNum + bs + 'px ' + famNum; nx.textAlign = 'center'; nx.fillStyle = '#fff'; nx.fillText(big, W / 2, base);
          var md = nx.getImageData(0, 0, W, GH).data;
          var A = function (xx, yy) { return (xx < 0 || yy < 0 || xx >= W || yy >= GH) ? 0 : md[(yy * W + xx) * 4 + 3]; };
          var gTop = GH, gBot = 0;
          for (var yy = 0; yy < GH; yy += 2) for (var xx = 0; xx < W; xx += 4) if (A(xx, yy) > 128) { if (yy < gTop) gTop = yy; if (yy > gBot) gBot = yy; }
          /* 2) relleno: líneas seguidas de nombres (en orden y repitiendo) que cubren todo el número y se recortan con su forma.
                Garantía: cada nombre de la lista aparece ENTERO al menos una vez; si no, se baja la letra y se vuelve a montar. */
          var inside = function (x0, x1, yTop, yBot) {
            for (var yy2 = Math.round(yTop); yy2 <= yBot; yy2 += Math.max(2, Math.round((yBot - yTop) / 3))) {
              for (var xx2 = Math.round(x0); xx2 <= x1; xx2 += 3) if (A(xx2, yy2) < 140) return false;
            }
            return true;
          };
          var tile = function (fs) {
            mc.font = '800 ' + fs + 'px ' + fam;
            var gap = fs * 0.55, lh = fs * 1.12, words = [], seen = {}, k = 0, row = 0;
            var wOf = names.map(function (n) { return mc.measureText(n).width; });
            for (var yb = gTop + fs * 0.9; yb <= gBot + fs; yb += lh, row++) {
              var xw = -((row * fs * 2.3) % (fs * 6));
              while (xw < W) {
                var i = k % names.length, w = wOf[i];
                words.push({ t: names[i], x: xw, y: yb, w: w });
                if (!seen[i] && inside(xw, xw + w, yb - fs * 0.74, yb)) seen[i] = true;
                xw += w + gap; k++;
              }
            }
            var all = true; for (var j = 0; j < names.length; j++) if (!seen[j]) { all = false; break; }
            return { fs: fs, words: words, ok: all };
          };
          var fsT = Math.max(12, Math.round(bs * 0.046)), tl = tile(fsT), tries = 0;
          while (!tl.ok && tries < 9 && fsT > 14) { fsT = Math.max(14, Math.round(fsT * 0.88)); tl = tile(fsT); tries++; }
          fit = tl.ok;
          var tc = document.createElement('canvas'); tc.width = W; tc.height = GH; var tx = tc.getContext('2d');
          tx.font = '800 ' + tl.fs + 'px ' + fam; tx.textAlign = 'left'; tx.fillStyle = c1;
          tl.words.forEach(function (wd) { tx.fillText(wd.t, wd.x, wd.y); });
          tx.globalCompositeOperation = 'destination-in'; tx.drawImage(nc, 0, 0);
          var repeated = true;
          var off = Math.max(0, gTop - 10);
          parts.push({ h: (gBot - off) + 14, draw: function (x, y0) {
            x.save(); x.textAlign = 'center'; x.font = wNum + bs + 'px ' + famNum; x.lineWidth = 7; x.strokeStyle = c2; x.strokeText(big, W / 2, y0 - off + base); x.restore();
            x.drawImage(tc, 0, y0 - off);
          } });
        } else {
          var fs2 = 54, rows2 = [];
          var lay = function (fs, maxW) {
            mc.font = '800 ' + fs + 'px ' + fam; var rows = [], row = '';
            names.forEach(function (n) { var t = row ? row + '   ' + n : n; if (mc.measureText(t).width > maxW && row) { rows.push(row); row = n; } else row = t; });
            if (row) rows.push(row); return rows;
          };
          rows2 = lay(fs2, 900);
          while (rows2.length * fs2 * 1.25 > 820 && fs2 > 16) { fs2 -= 2; rows2 = lay(fs2, 900); }
          parts.push({ h: Math.round(rows2.length * fs2 * 1.25 + fs2 * 0.5), draw: function (x, y0) {
            x.textAlign = 'center'; x.fillStyle = c1; x.font = '800 ' + fs2 + 'px ' + fam;
            rows2.forEach(function (r, i) { x.fillText(r, W / 2, y0 + fs2 * 1.1 + i * fs2 * 1.25); });
          } });
          if (big) parts.push({ h: 210, draw: function (x, y0) { x.textAlign = 'center'; x.fillStyle = c2; x.font = '900 180px ' + fam; x.fillText(big, W / 2, y0 + 175); } });
        }
        if (foot) parts.push({ h: 96, draw: function (x, y0) { x.textAlign = 'center'; x.fillStyle = c2; x.font = '700 52px ' + fam; x.fillText(foot, W / 2, y0 + 66); } });
        var H = parts.reduce(function (s, p) { return s + p.h; }, 0) + 12;
        var c = document.createElement('canvas'); c.width = W; c.height = H; var x = c.getContext('2d'); x.textBaseline = 'alphabetic';
        var yy2 = 0; parts.forEach(function (p) { p.draw(x, yy2); yy2 += p.h; });
        var d = x.getImageData(0, 0, W, H).data, N = W * H, a = new Uint8Array(N), lin = new Float32Array(N * 3), minX = W, maxX = -1, minY = H, maxY = -1;
        for (var i = 0, q = 0; i < N; i++, q += 4) {
          a[i] = d[q + 3]; lin[i * 3] = LIN[d[q]]; lin[i * 3 + 1] = LIN[d[q + 1]]; lin[i * 3 + 2] = LIN[d[q + 2]];
          if (a[i] > 16) { var xx2 = i % W, yy3 = (i / W) | 0; if (xx2 < minX) minX = xx2; if (xx2 > maxX) maxX = xx2; if (yy3 < minY) minY = yy3; if (yy3 > maxY) maxY = yy3; }
        }
        namesCache = { key: key, fit: fit, bmp: maxX < 0 ? null : { W: W, H: H, a: a, lin: lin, bx: minX, by: minY, bw: maxX - minX + 1, bh: maxY - minY + 1 } };
        var fitEl = cz.querySelector('[data-names-fit]');
        if (fitEl) {
          fitEl.hidden = !(style === 'numero' && big);
          var nTot = list.length;
          fitEl.textContent = fit ? 'Están los ' + nTot + ' nombres dentro del número' + (repeated ? ' y repetimos algunos para que quede lleno.' : '.') : 'Son demasiados nombres para este número: probad el estilo «Bloque de nombres» o un número con más cifras.';
          fitEl.classList.toggle('is-warn', !fit);
        }
        return namesCache.bmp;
      }
      function paintNames(o, V, shBuf) {
        var b = namesBitmap(); if (!b) return;
        var z = PRINT[pvActive] || PRINT.hoodie, hoodPad = (pvActive === 'hoodie' || pvActive === 'zipper') ? 0.04 * V.H : 0;
        /* margen inferior: el texto de abajo no debe tocar el borde de la zona imprimible (canal R de la máscara) */
        var bw = z.w * V.W, bh = (z.h * V.H - hoodPad) * 0.9, s = Math.min(bw / b.bw, bh / b.bh), dh = b.bh * s;
        var top = z.top * V.H + hoodPad;
        lastPrintBottom = paintBmp(o, V, shBuf, b, z.cx * V.W, top + dh / 2, bw, bh, null, V.pm);
      }
      /* VERSION_CARLOS: texto y mapas de bits genericos sobre la prenda (iniciales en el pecho, nombre de prueba, logo en el pecho) */
      var lastPrintBottom = 0;
      function textBitmap(txt, px) {
        var c = document.createElement('canvas'), x = c.getContext('2d');
        var fam = (getComputedStyle(document.body).fontFamily || 'sans-serif');
        x.font = '800 ' + px + 'px ' + fam;
        var w = Math.ceil(x.measureText(txt).width) + 12, h = Math.ceil(px * 1.35);
        c.width = Math.max(1, w); c.height = h;
        x.font = '800 ' + px + 'px ' + fam; x.textBaseline = 'middle'; x.fillStyle = '#fff'; x.fillText(txt, 6, h / 2);
        var d = x.getImageData(0, 0, c.width, h).data, N = c.width * h, a = new Uint8Array(N), minX = c.width, maxX = -1, minY = h, maxY = -1;
        for (var i = 0; i < N; i++) { a[i] = d[i * 4 + 3]; if (a[i] > 16) { var xx = i % c.width, yy = (i / c.width) | 0; if (xx < minX) minX = xx; if (xx > maxX) maxX = xx; if (yy < minY) minY = yy; if (yy > maxY) maxY = yy; } }
        if (maxX < 0) return null;
        return { W: c.width, H: h, a: a, lin: null, bx: minX, by: minY, bw: maxX - minX + 1, bh: maxY - minY + 1 };
      }
      function autoInk() {
        var gc = linRgb(state.hoodie || '#FFFFFF'), glum = 0.2126 * gc[0] + 0.7152 * gc[1] + 0.0722 * gc[2];
        return linRgb(state.print || (glum > 0.35 ? '#234056' : '#FFFFFF'));
      }
      /* pinta un mapa de bits centrado en (cx, cy) dentro de una caja maxW x maxH; col = color lineal fijo o null (colores propios) */
      function paintBmp(o, V, shBuf, d, cx, cy, maxW, maxH, col, clipArr) {
        var scale = Math.min(maxW / d.bw, maxH / d.bh);
        var dw = Math.max(1, Math.round(d.bw * scale)), dh = Math.max(1, Math.round(d.bh * scale));
        var x0 = Math.round(cx - dw / 2), y0 = Math.round(cy - dh / 2), inv = 1 / scale;
        for (var y = 0; y < dh; y++) {
          var Y = y0 + y; if (Y < 0 || Y >= V.H) continue;
          var sy = d.by + Math.min(d.bh - 1, (y * inv) | 0);
          for (var x = 0; x < dw; x++) {
            var X = x0 + x; if (X < 0 || X >= V.W) continue;
            var si = sy * d.W + d.bx + Math.min(d.bw - 1, (x * inv) | 0), da = d.a[si]; if (!da) continue;
            var i = Y * V.W + X, clip = clipArr ? clipArr[i] : V.alpha[i]; if (!clip) continue;
            var sh = 0.82 + 0.18 * shBuf[i], al = (da / 255) * (clip / 255) * 0.96, pp = i * 4;
            var r = col ? col[0] : d.lin[si * 3], g = col ? col[1] : d.lin[si * 3 + 1], b = col ? col[2] : d.lin[si * 3 + 2];
            o[pp] = o[pp] * (1 - al) + toSrgb(r * sh) * al;
            o[pp + 1] = o[pp + 1] * (1 - al) + toSrgb(g * sh) * al;
            o[pp + 2] = o[pp + 2] * (1 - al) + toSrgb(b * sh) * al;
          }
        }
        return y0 + dh;
      }
      function paintExtras(o, V, shBuf, view) {
        var persos = state.persos || [];
        if (view === 'back') {
          var nm = persos.indexOf('nombre') > -1 && state.nombrePrueba ? String(state.nombrePrueba).toUpperCase().slice(0, 14) : '';
          if (nm) {
            var z = PRINT[pvActive] || PRINT.hoodie, zb = (z.top + z.h + 0.05) * V.H, bm = textBitmap(nm, 120);
            if (bm) {
              var top = lastPrintBottom ? lastPrintBottom + 0.016 * V.H : z.top * V.H + 0.06 * V.H;
              var room = zb - top, hh = Math.min(0.05 * V.H, room);
              /* el nombre puede bajar hasta el final del cuerpo (canal G), no solo la zona del estampado */
              if (hh > 0.02 * V.H) paintBmp(o, V, shBuf, bm, z.cx * V.W, top + hh / 2, z.w * V.W * 0.8, hh, autoInk(), V.bd || V.pm);
            }
          }
        } else {
          var dz = (C.designZones || {})[pvActive] || {}, fz = dz.front || { top: 0.34, width: 0.3 };
          var cx = (0.5 + 0.135) * V.W, cy = (fz.top + 0.035) * V.H, clip = V.bd || V.alpha;
          if (state.dsrc === 'own' && ownLogo && state.logoOpts && state.logoOpts.chest) {
            paintBmp(o, V, shBuf, ownLogo, cx, cy, 0.1 * V.W, 0.075 * V.H, state.logoOpts.mono ? autoInk() : null, clip);
          } else if (persos.indexOf('iniciales') > -1 && state.iniciales) {
            var ib = textBitmap(String(state.iniciales).toUpperCase().slice(0, 4), 120);
            if (ib) paintBmp(o, V, shBuf, ib, cx, cy, 0.085 * V.W, 0.032 * V.H, autoInk(), clip);
          }
        }
      }
      var PRINT = C.printZones || {};
      var DESIGN_SRC = ['#FFFFFF', '#B2B2B2'];   /* colores fuente de las plantillas estandar (slot 1, slot 2) */
      function flagKey() {
        var on = (state.persos || []).indexOf('bandera') > -1 && state.bandera && state.bandera !== 'Sin bandera';
        return on ? state.bandera : '';
      }
      function requestRender(force) {
        var key = pvActive + '|' + (state.hoodie || '') + '|' + (state.print || '') + '|' + (state.print2 || '') + '|' + (state.designOverlay || '') + '|' + flagKey() + '|' + (state.dsrc === 'own' && ownLogo ? 'logo' + ownVer + (state.logoOpts.mono ? 'm' : '') + (state.logoOpts.chest ? 'c' : '') : '') + '|' + (state.iniciales || '') + '|' + (state.nombrePrueba || '') + '|' + (state.dsrc === 'names' ? [state.namesText, state.namesBig, state.namesTitle, state.namesFoot, state.namesStyle].join('~') : '') + '|' + (state.persos || []).join(',');
        if (!force && key === pvLast) return;
        pvLast = key;
        if (pvRaf) return;
        pvRaf = true;
        /* v14.3: rAF + temporizador de respaldo (rAF no se dispara en ventanas minimizadas o en segundo plano) */
        var done = false, run = function () {
          if (done) return; done = true;
          pvRaf = false;
          renderView('back');
          renderView('front');
        };
        if (!document.hidden && window.requestAnimationFrame) window.requestAnimationFrame(run);
        setTimeout(run, document.hidden ? 16 : 150);
      }
      var SLEEVES = C.sleeves || {};
      var FLAGS = C.flags || {};
      function sleevePoint(view, wearerSide) {
        var s = SLEEVES[pvActive] || SLEEVES.hoodie;
        if (!s || !s[view]) return null;
        /* lado fisico del portador -> lado visual: en la delantera se invierte */
        var visual = view === 'front' ? (wearerSide === 'left' ? 'right' : 'left')
                                      : (wearerSide === 'left' ? 'left' : 'right');
        return s[view][visual] || null;
      }
      function syncSleeves() {
        var persos = state.persos || [];
        var flagOn = persos.indexOf('bandera') > -1 && state.bandera && state.bandera !== 'Sin bandera' && FLAGS[state.bandera];
        /* v14.1: la bandera se estampa en el lienzo (paintFlag). La imagen superpuesta queda oculta salvo si el
           lienzo no puede leer pixeles (fallback del comportamiento anterior). */
        var entry = pvCache[pvActive];
        var canvasOk = entry && entry.ready && entry.views && entry.views.back && !entry.views.back.tainted;
        if (canvasOk || !flagOn) {
          cz.querySelectorAll('[data-pv-flag]').forEach(function (f) { f.setAttribute('hidden', ''); });
          requestRender();
          return;
        }
        ['back', 'front'].forEach(function (v) {
          var f = cz.querySelector('[data-pv-flag="' + v + '"]');
          if (f) {
            var pF = flagOn ? sleevePoint(v, 'left') : null;
            if (pF) f.removeAttribute('hidden'); else f.setAttribute('hidden', '');
            if (pF) {
              if (f.getAttribute('src') !== FLAGS[state.bandera]) f.setAttribute('src', FLAGS[state.bandera]);
              f.style.left = (pF.x * 100) + '%';
              f.style.top = (pF.y * 100) + '%';
              if (pF.w) { f.style.width = (pF.w * 100) + '%'; f.style.maxWidth = (pF.w * 100) + '%'; }
              f.style.transform = 'translate(-50%,-50%) rotate(' + (pF.rot || 0) + 'deg)';
            }
          }
        });
      }
      (function () {
        var preview = cz.querySelector('.customizer__preview');
        var sentinel = cz.querySelector('[data-cz-sentinel]');
        if (!preview || !sentinel) return;
        /* top del sticky = borde inferior REAL del header fijo (announcement incluida) + 6px;
           si el header no es sticky/fixed, la preview sube al borde superior (6px). */
        function syncStickyTop() {
          var top = 6;
          var hdr = document.querySelector('.site-header');
          if (hdr) {
            var pos = getComputedStyle(hdr).position;
            if (pos === 'sticky' || pos === 'fixed') {
              var hb = hdr.getBoundingClientRect();
              if (hb.height > 0) top = Math.max(6, Math.round(Math.min(hb.bottom, hb.height)) + 6);
            }
          }
          preview.style.setProperty('--cz-sticky-top', top + 'px');
        }
        syncStickyTop();
        window.addEventListener('resize', syncStickyTop);
        window.addEventListener('orientationchange', function () { setTimeout(syncStickyTop, 250); });
        if ('IntersectionObserver' in window) {
          /* compacta ~260px antes de que el bloque llegue arriba: nunca se ancla el hero grande */
          var io = new IntersectionObserver(function (entries) {
            preview.classList.toggle('is-compact', !entries[0].isIntersecting);
          }, { rootMargin: '-260px 0px 0px 0px' });
          io.observe(sentinel);
        }
      })();
      function applyZone(id) {
        var z = (ZONES[id] || ZONES.hoodie || {}).back;
        if (pvText && z) {
          pvText.style.top = (z.top * 100) + '%';
          pvText.style.width = (z.width * 100) + '%';
        }
      }
      function setView(v, fromUser) {
        state.view = v;
        if (stage) stage.classList.toggle('is-front', v === 'front');
        if (rotateBtn) {
          rotateBtn.classList.toggle('is-front', v === 'front');
          rotateBtn.setAttribute('aria-pressed', v === 'front' ? 'true' : 'false');
          rotateBtn.setAttribute('aria-label', v === 'front' ? 'Mostrar parte trasera de la prenda' : 'Mostrar parte delantera de la prenda');
        }
        if (rotateLabel) rotateLabel.textContent = v === 'front' ? 'Ver espalda' : 'Ver delantera';
        if (viewtag) viewtag.textContent = v === 'front' ? 'DELANTERA \u00b7 2/2' : 'ESPALDA \u00b7 1/2';
        if (fromUser) dl('garment_view_flipped', { view: v });
        save();
      }
      function flipView() { setView(state.view === 'front' ? 'back' : 'front', true); }
      function activateGarment(id) {
        if (!MOCKS[id]) id = 'hoodie';
        pvActive = id;
        applyZone(id);
        setView('back');
        loadGarment(id, function () { requestRender(true); });
      }
      if (rotateBtn) rotateBtn.addEventListener('click', flipView);
      if (stage && window.PointerEvent) {
        var swipeX = null;
        stage.addEventListener('pointerdown', function (e) { swipeX = e.clientX; });
        stage.addEventListener('pointerup', function (e) {
          if (swipeX != null && Math.abs(e.clientX - swipeX) > 40) flipView();
          swipeX = null;
        });
      }

      function setVar(name, val) { if (frame) frame.style.setProperty(name, val); }
      function chip(label, dot) {
        var d = dot ? '<span class="chip__dot" style="background:' + dot + '"></span>' : '';
        return '<span class="chip">' + d + label + '</span>';
      }
      function refresh() {
        var nameOn = (state.persos || []).indexOf('nombre') > -1 && state.nombre;
        if (pvText) { if (nameOn) pvText.removeAttribute('hidden'); else pvText.setAttribute('hidden', ''); }
        if (pvName) {
          var nm = nameOn ? String(state.nombre).toUpperCase() : '';
          pvName.textContent = nm;
          var owner = pvName.closest ? pvName.closest('text') : null;
          var fs = nm.length > 18 ? 54 : nm.length > 14 ? 66 : nm.length > 9 ? 80 : 92;
          (owner || pvName).setAttribute('font-size', fs);
        }
        syncSleeves();
        if (window.__czSyncPersos) window.__czSyncPersos();
        if (typeof syncSteps === 'function') syncSteps();
        if (state.hoodie) { setVar('--cz-hoodie', state.hoodie); cz.style.setProperty('--cz-hoodie', state.hoodie); }
        if (state.print) { setVar('--cz-print', state.print); cz.style.setProperty('--cz-print', state.print); }
        if (state.designOverlay && !(designCache[state.designOverlay] && designCache[state.designOverlay].ready)) {
          loadDesign(state.designOverlay, function () { syncPrintSlots(); save(); requestRender(true); });
        }
        syncPrintSlots();
        requestRender();
        if (chips) {
          var h = [];
          if (state.prendaLabel) h.push(chip(ICON.shirt + state.prendaLabel));
          if (state.group) h.push(chip(state.group));
          if (state.hoodie) h.push(chip('Prenda ' + state.hoodie, state.hoodie));
          if (state.print) h.push(chip('Dise\u00f1o ' + state.print, state.print));
          if (state.print2) h.push(chip('Dise\u00f1o 2 ' + state.print2, state.print2));
          (state.persos || []).forEach(function (pid) {
            var p = persoById(pid);
            if (p) h.push(chip(ICON.sparkles + p.label));
          });
          if (state.bandera && state.bandera !== 'Sin bandera' && (state.persos || []).indexOf('bandera') > -1) h.push(chip(ICON.flag + state.bandera));
          if (state.design) h.push(chip(ICON.image + state.design));
          chips.innerHTML = h.join('');
        }
        if (hint && state.hoodie && state.print) hint.hidden = contrast(state.hoodie, state.print) >= 2.5;
        var persoTxt = (state.persos || []).map(function (pid) { var p = persoById(pid); return p ? p.label : pid; }).join(', ');
        var cfgVal = ['Prenda: ' + (state.prendaLabel || '\u2014'), 'Grupo: ' + (state.group || '\u2014'), 'Dise\u00f1o: ' + (state.design || '\u2014'),
          'Color prenda: ' + (state.hoodie || '\u2014'), 'Color dise\u00f1o: ' + (state.print || '\u2014') + (state.print2 ? ' / color 2: ' + state.print2 : ''), 'Archivo: ' + (state.fileUrl || state.fileName || '\u2014'),
          'Personalizaciones: ' + (persoTxt || '\u2014'), 'Bandera: ' + (state.bandera || '\u2014')
        ].join(' | ');
        document.querySelectorAll('[data-cz-config]').forEach(function (hc) { hc.value = cfgVal; });
        save();
      }

      /* PASO 1 \u2014 prenda */
      var prendaCards = cz.querySelectorAll('[data-prenda]');
      prendaCards.forEach(function (card) {
        card.addEventListener('click', function () {
          var wasOn = card.getAttribute('aria-pressed') === 'true';
          prendaCards.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          if (wasOn) {
            /* v14.2: segundo clic = sin prenda (la vista previa vuelve a la base neutra) */
            state.prenda = null; state.prendaLabel = null;
            dl('garment_cleared', {});
            activateGarment('hoodie');
            refresh();
            return;
          }
          card.setAttribute('aria-pressed', 'true');
          state.prenda = card.getAttribute('data-prenda');
          state.prendaLabel = card.getAttribute('data-prenda-label');
          dl('garment_selected', { garment: state.prenda });
          activateGarment(state.prenda);
          refresh();
        });
        if (state.prenda && card.getAttribute('data-prenda') === state.prenda) card.setAttribute('aria-pressed', 'true');
      });
      activateGarment(state.prenda && MOCKS[state.prenda] ? state.prenda : 'hoodie');

      /* PASO 6 \u2014 personalizaciones (multi) + PASO 7 condicional */
      var persoChecks = cz.querySelectorAll('[data-perso]');
      var persoDetails = cz.querySelector('[data-perso-details]');
      function syncPersoDetails() {
        var sel = state.persos || [];
        var anyDetail = false;
        cz.querySelectorAll('[data-perso-detail]').forEach(function (d) {
          var on = sel.indexOf(d.getAttribute('data-perso-detail')) > -1;
          d.hidden = !on;
          if (on) anyDetail = true;
        });
        if (persoDetails) persoDetails.hidden = !anyDetail;
      }
      persoChecks.forEach(function (chk) {
        var id = chk.getAttribute('data-perso');
        if ((state.persos || []).indexOf(id) > -1) chk.checked = true;
        chk.addEventListener('change', function () {
          state.persos = state.persos || [];
          var i = state.persos.indexOf(id);
          if (chk.checked && i === -1) state.persos.push(id);
          if (!chk.checked && i > -1) state.persos.splice(i, 1);
          dl('personalization_toggled', { id: id, on: chk.checked, selected: state.persos.join(',') });
          syncPersoDetails();
          refresh();
        });
      });
      syncPersoDetails();

      var groupCards = cz.querySelectorAll('[data-group]');
      function filterDesigns() {
        var g = norm(state.group);
        cz.querySelectorAll('[data-design-card]').forEach(function (card) {
          var cat = norm(card.getAttribute('data-cat'));
          card.hidden = !(!g || !cat || cat === 'todos' || cat === g);
        });
      }
      groupCards.forEach(function (card) {
        card.addEventListener('click', function () {
          groupCards.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          card.setAttribute('aria-pressed', 'true');
          state.group = card.getAttribute('data-group');
          dl('group_type_selected', { group_type: state.group });
          filterDesigns(); refresh();
        });
        if (state.group && card.getAttribute('data-group') === state.group) card.setAttribute('aria-pressed', 'true');
      });

      var designCards = cz.querySelectorAll('[data-design-card]');
      designCards.forEach(function (card) {
        card.addEventListener('click', function () {
          var wasOn = card.getAttribute('aria-pressed') === 'true';
          designCards.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          if (wasOn) {
            /* v14.1: segundo clic = deseleccionar (opcional). Se limpian diseno, overlay y colores ligados al diseno */
            state.design = null; state.designImg = null; state.designOverlay = null; state.print2 = null;
            dl('design_cleared', {});
            refresh();
            return;
          }
          card.setAttribute('aria-pressed', 'true');
          state.design = card.getAttribute('data-design');
          state.designImg = card.getAttribute('data-img') || null;
          state.designOverlay = card.getAttribute('data-overlay') || null;
          if (state.designOverlay) setView('back');
          state.designCat = state.group || state.designCat || 'todos';
          dl('design_selected', { design: state.design });
          refresh();
        });
        if (state.design && card.getAttribute('data-design') === state.design) card.setAttribute('aria-pressed', 'true');
      });

      /* v14.1: slots de color del diseno. El slot 2 solo aparece si la plantilla elegida contiene #B2B2B2;
         si deja de aplicar, su color se borra del estado (no quedan referencias obsoletas en el lead). */
      function syncPrintSlots() {
        var d = state.designOverlay ? designCache[state.designOverlay] : null;
        var two = !!(d && d.ready && d.hasSecondary);
        var wrap2 = cz.querySelector('[data-print-slot="2"]');
        if (wrap2) wrap2.hidden = !two;
        cz.querySelectorAll('[data-slot-label]').forEach(function (l) { l.hidden = !two; });
        if (!two && state.print2 && (!d || d.ready)) state.print2 = null;
        (PRINT_SLOTS || []).forEach(function (sl) {
          var cur = normHex(state[sl.target]);
          sl.scope.querySelectorAll('[data-sw-hex]').forEach(function (b) {
            b.setAttribute('aria-pressed', cur && normHex(b.getAttribute('data-sw-hex')) === cur ? 'true' : 'false');
          });
        });
        var rst = cz.querySelector('[data-print-reset]');
        if (rst) rst.hidden = !(state.print || state.print2);
      }
      var PRINT_SLOTS = [];
      cz.querySelectorAll('[data-cp]').forEach(function (cp) {
        var target = cp.getAttribute('data-cp');
        var picker = cp.querySelector('input[type=color]');
        var hexIn = cp.querySelector('[data-cp-hex]');
        var rgbOut = cp.querySelector('[data-cp-rgb]');
        function apply(hex, from) {
          var h = normHex(hex); if (!h) return;
          state[target] = h;
          if (picker && from !== 'picker') picker.value = h;
          if (hexIn && from !== 'hex') hexIn.value = h;
          if (rgbOut) { var c = hexToRgb(h); rgbOut.textContent = 'RGB ' + c.r + ', ' + c.g + ', ' + c.b; }
          dl('color_selected', { target: target, hex: h });
          refresh();
        }
        if (picker) picker.addEventListener('input', function () { apply(picker.value, 'picker'); });
        if (hexIn) hexIn.addEventListener('change', function () {
          var h = normHex(hexIn.value);
          if (h) apply(h, 'hex'); else hexIn.value = state[target] || '';
        });
        var swScope = cp.closest('.cz-colorpick') || cp.parentElement;
        /* v14.2: todos los colores admiten toggle (segundo clic = sin color; la prenda vuelve a blanco y el diseño a su color original) */
        var optional = true;
        var SRC = target === 'print2' ? DESIGN_SRC[1] : DESIGN_SRC[0];
        function clearSlot() {
          state[target] = null;
          if (picker) picker.value = SRC;
          if (hexIn) hexIn.value = SRC;
          if (rgbOut) { var c0 = hexToRgb(SRC); rgbOut.textContent = 'RGB ' + c0.r + ', ' + c0.g + ', ' + c0.b; }
          dl('color_cleared', { target: target });
          refresh();
        }
        swScope.querySelectorAll('[data-sw-hex]').forEach(function (sw) {
          sw.addEventListener('click', function () {
            var h = normHex(sw.getAttribute('data-sw-hex'));
            if (optional && h && normHex(state[target]) === h) { clearSlot(); return; }
            apply(h, 'sw');
          });
        });
        if (optional) PRINT_SLOTS.push({ target: target, scope: swScope });
        if (state[target]) apply(state[target], 'init');
      });

      /* VERSION_CARLOS: iniciales (pecho) y nombre de prueba (espalda) en la vista previa */
      var inIni = cz.querySelector('[data-cz-iniciales]'), inNp = cz.querySelector('[data-cz-nombre-prueba]');
      if (inIni) { if (state.iniciales) inIni.value = state.iniciales; inIni.addEventListener('input', function () { state.iniciales = inIni.value.replace(/[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ.&]/g, '').slice(0, 4); if (inIni.value !== state.iniciales) inIni.value = state.iniciales; save(); if (typeof setView === 'function') { try { setView('front'); } catch (e) {} } refresh(); }); }
      if (inNp) { if (state.nombrePrueba) inNp.value = state.nombrePrueba; inNp.addEventListener('input', function () { state.nombrePrueba = inNp.value.slice(0, 14); save(); refresh(); }); }
      /* VERSION_CARLOS: «Nombre» = nombre del colegio, grupo o clase que sustituye a NOMBRE en el diseño. No se pinta: se manda el ejemplo */
      delete state.nombrePrueba;
      var inNg = cz.querySelector('[data-cz-nombre-grupo]');
      if (inNg) { if (state.nombreGrupo) inNg.value = state.nombreGrupo; inNg.addEventListener('input', function () { state.nombreGrupo = inNg.value.slice(0, 30); save(); }); }
      var inName = cz.querySelector('[data-cz-nombre]');
      if (inName) {
        if (state.nombre) inName.value = state.nombre;
        inName.addEventListener('input', function () { state.nombre = inName.value; refresh(); });
      }

      var flag = cz.querySelector('[data-cz-bandera]');
      if (flag) {
        if (state.bandera) flag.value = state.bandera;
        flag.addEventListener('change', function () {
          state.bandera = flag.value;
          dl('flag_selected', { flag: flag.value });
          refresh();
        });
      }

      /* ===== v11: gama, diseno propio, scopes, cuantos sois, destino, pasos ===== */
      var tierCards = cz.querySelectorAll('[data-tier]');
      var garmentGrid = cz.querySelector('[data-garment-grid]');
      function applyTier() {
        var t = state.tier;
        tierCards.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-tier') === t ? 'true' : 'false'); });
        if (garmentGrid) garmentGrid.hidden = !t;
        if (t) {
          var currentOk = false;
          cz.querySelectorAll('[data-prenda]').forEach(function (c) {
            var of = c.getAttribute('data-tier-of') || '';
            var show = of.indexOf(t) > -1;
            c.hidden = !show;
            if (show && state.prenda && c.getAttribute('data-prenda') === state.prenda) currentOk = true;
          });
          if (state.prenda && !currentOk) {
            state.prenda = null; state.prendaLabel = null;
            cz.querySelectorAll('[data-prenda]').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          }
          if (state.tier !== 'ultra' && (state.persos || []).indexOf('desgastado') > -1) {
            state.persos.splice(state.persos.indexOf('desgastado'), 1);
            var dchk = cz.querySelector('[data-perso="desgastado"]');
            if (dchk) dchk.checked = false;
          }
        }
        syncPersoRows();
      }
      /* VERSION_CARLOS: el desgastado solo existe en Ultra Premium; con el diseño «nombres de la clase» no se ofrece «Nombre» */
      function syncPersoRows() {
        var t = state.tier, names = state.dsrc === 'names';
        cz.querySelectorAll('[data-perso-tier]').forEach(function (row) {
          var of = row.getAttribute('data-perso-tier') || '', pid = row.getAttribute('data-perso-row');
          var off = t ? of.indexOf(t) === -1 : of.indexOf('premium') === -1;
          if (pid === 'nombre' && names) off = true;
          row.hidden = off;
          if (off && (state.persos || []).indexOf(pid) > -1) {
            state.persos.splice(state.persos.indexOf(pid), 1); save();
            var chk = row.querySelector('[data-perso]'); if (chk) chk.checked = false;
            var ex = row.querySelector('[data-perso-extra]'); if (ex) ex.hidden = true;
          }
        });
      }
      window.__czSyncPersos = syncPersoRows;
      tierCards.forEach(function (c) {
        c.addEventListener('click', function () {
          var v = c.getAttribute('data-tier');
          if (state.tier === v) {
            /* v14.2: segundo clic = sin gama; la prenda elegida depende de la gama, asi que tambien se limpia */
            state.tier = null; state.prenda = null; state.prendaLabel = null;
            cz.querySelectorAll('[data-prenda]').forEach(function (p2) { p2.setAttribute('aria-pressed', 'false'); });
            dl('tier_cleared', {});
          } else {
            state.tier = v;
            dl('tier_selected', { tier: state.tier });
          }
          applyTier(); refresh();
        });
      });

      /* origen del diseno */
      var srcCards = cz.querySelectorAll('[data-dsrc]');
      function applyDsrc() {
        srcCards.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-dsrc') === state.dsrc ? 'true' : 'false'); });
        cz.querySelectorAll('[data-dsrc-panel]').forEach(function (p2) {
          p2.hidden = p2.getAttribute('data-dsrc-panel') !== state.dsrc;
        });
      }
      srcCards.forEach(function (c) {
        c.addEventListener('click', function () {
          var v = c.getAttribute('data-dsrc');
          if (state.dsrc === v) {
            /* v14.1: segundo clic = sin origen de diseno (opcional); se limpia lo que dependia de esa opcion */
            state.dsrc = null;
            if (v === 'standard') { state.design = null; state.designImg = null; state.designOverlay = null; state.print2 = null; cz.querySelectorAll('[data-design-card]').forEach(function (d) { d.setAttribute('aria-pressed', 'false'); }); }
            if (v === 'own') { state.fileName = null; state.fileUrl = null; state.designHelp = false; var hb = cz.querySelector('[data-cz-help]'); if (hb) hb.setAttribute('aria-pressed', 'false'); }
            dl('design_source_cleared', { source: v });
            applyDsrc(); refresh();
            return;
          }
          state.dsrc = v;
          if (state.dsrc === 'own' || state.dsrc === 'names') { state.design = null; state.designImg = null; state.designOverlay = null; cz.querySelectorAll('[data-design-card]').forEach(function (d) { d.setAttribute('aria-pressed', 'false'); }); }
          if (state.dsrc === 'names') syncNamesUi();
          dl('design_source_selected', { source: state.dsrc });
          applyDsrc(); refresh();
        });
      });

      /* ===== v14.1: navegacion por tipos de diseno =====
         Diseños estandar -> tipos (derivados de los bloques "Tipo de grupo" + categorias reales de los disenos)
         -> disenos de ese tipo. Los chips existentes se reutilizan como tarjetas de tipo. */
      var catWrap = cz.querySelector('[data-cz-cats]');
      var catBar = cz.querySelector('[data-cz-catbar]');
      var catTitle = cz.querySelector('[data-cz-cat-title]');
      var dgrid = cz.querySelector('[data-dgrid]');
      if (catWrap) {
        /* categorias presentes en los disenos que no tengan tarjeta propia -> se crean a partir de los datos */
        var known = {};
        catWrap.querySelectorAll('[data-cat-chip]').forEach(function (c) { known[norm(c.getAttribute('data-cat-chip'))] = true; });
        var tpl = catWrap.querySelector('[data-cat-chip]:not([data-cat-chip="todos"])');
        cz.querySelectorAll('[data-design-card]').forEach(function (card) {
          var cat = card.getAttribute('data-cat') || '';
          if (!cat || norm(cat) === 'todos' || known[norm(cat)] || !tpl) return;
          known[norm(cat)] = true;
          var nc = tpl.cloneNode(true);
          nc.setAttribute('data-cat-chip', cat);
          nc.textContent = cat;
          catWrap.appendChild(nc);
        });
        /* recuento y miniaturas por tipo */
        catWrap.querySelectorAll('[data-cat-chip]').forEach(function (c) {
          var g = norm(c.getAttribute('data-cat-chip'));
          var cards = Array.prototype.filter.call(cz.querySelectorAll('[data-design-card]'), function (card) {
            var cat = norm(card.getAttribute('data-cat'));
            return g === 'todos' || !cat || cat === 'todos' || cat === g;
          });
          if (!cards.length) { c.hidden = true; return; }
          var thumbs = document.createElement('span'); thumbs.className = 'czcat__thumbs'; thumbs.setAttribute('aria-hidden', 'true');
          cards.slice(0, 3).forEach(function (card) {
            var im = card.querySelector('img'); if (!im) return;
            var t = document.createElement('img'); t.src = im.getAttribute('src'); t.alt = ''; t.loading = 'lazy'; t.width = 48; t.height = 48;
            thumbs.appendChild(t);
          });
          var n = document.createElement('span'); n.className = 'czcat__n';
          n.textContent = cards.length + (cards.length === 1 ? ' diseño' : ' diseños');
          if (g === 'todos') { c.lastChild && c.lastChild.nodeType === 3 ? c.lastChild.textContent = 'Ver todos' : c.appendChild(document.createTextNode('Ver todos')); }
          c.insertBefore(thumbs, c.firstChild);
          c.appendChild(n);
          c.classList.add('czcat');
        });
        catWrap.classList.add('cz-cats');
      }
      function applyDesignNav() {
        if (!catWrap) return;
        var open = state.designCat != null;
        catWrap.hidden = open;
        var hint = cz.querySelector('[data-cz-cats-hint]');
        if (hint) hint.hidden = open;
        if (catBar) catBar.hidden = !open;
        if (dgrid) dgrid.hidden = !open;
        if (catTitle) catTitle.textContent = open ? (state.designCat === 'todos' ? 'Todos los diseños' : state.designCat) : '';
        catWrap.querySelectorAll('[data-cat-chip]').forEach(function (c) {
          c.setAttribute('aria-pressed', open && c.getAttribute('data-cat-chip') === state.designCat ? 'true' : 'false');
        });
      }
      var catChips = cz.querySelectorAll('[data-cat-chip]');
      catChips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var v = chip.getAttribute('data-cat-chip');
          state.group = v === 'todos' ? null : v;
          state.designCat = v;
          dl('design_category_opened', { category: v });
          filterDesigns(); applyDesignNav(); refresh();
          if (dgrid && window.innerWidth <= 940) dgrid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });
      var catBack = cz.querySelector('[data-cz-cat-back]');
      if (catBack) catBack.addEventListener('click', function () {
        state.designCat = null;
        applyDesignNav(); save();
        var first = catWrap && catWrap.querySelector('[data-cat-chip]:not([hidden])');
        if (first) first.focus();
      });
      if (state.designCat != null) { state.group = state.designCat === 'todos' ? null : state.designCat; }
      applyDesignNav();

      /* ===== v14: archivo propio \u2014 se sube a la nube y su ENLACE viaja en el WhatsApp y en el lead =====
         wa.me no admite adjuntos: es una limitacion de WhatsApp. Con un servicio configurado (Cloudinary/Uploadcare)
         el archivo llega siempre. Sin servicio, en movil se ofrece el menu nativo "Compartir" con el archivo adjunto. */
      var fileIn = cz.querySelector('[data-cz-file]');
      var fileInfo = cz.querySelector('[data-cz-file-info]');
      var fileNote = cz.querySelector('[data-cz-file-note]');
      var fileOk = cz.querySelector('[data-cz-file-ok]');
      var fileBar = cz.querySelector('[data-cz-file-bar]');
      var shareBtn = cz.querySelector('[data-cz-share]');
      var sessionFile = null;
      var UP = C.upload || {};
      function uploadEndpoint() {
        if (UP.provider === 'cloudinary' && UP.cloud && UP.preset) return { url: 'https://api.cloudinary.com/v1_1/' + encodeURIComponent(UP.cloud) + '/auto/upload', kind: 'cloudinary' };
        if (UP.provider === 'uploadcare' && UP.uploadcareKey) return { url: 'https://upload.uploadcare.com/base/', kind: 'uploadcare' };
        return null;
      }
      function uploadFile(f, onProgress) {
        return new Promise(function (resolve, reject) {
          var ep = uploadEndpoint();
          if (!ep) return reject('no-provider');
          var fd = new FormData();
          if (ep.kind === 'cloudinary') { fd.append('file', f); fd.append('upload_preset', UP.preset); fd.append('folder', 'customly-leads'); fd.append('tags', 'lead-web'); }
          else { fd.append('UPLOADCARE_PUB_KEY', UP.uploadcareKey); fd.append('UPLOADCARE_STORE', '1'); fd.append('file', f); }
          var x = new XMLHttpRequest();
          x.open('POST', ep.url);
          x.upload.onprogress = function (e) { if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total); };
          x.onload = function () {
            try {
              var j = JSON.parse(x.responseText);
              if (ep.kind === 'cloudinary' && j.secure_url) return resolve(j.secure_url);
              if (ep.kind === 'uploadcare' && j.file) return resolve('https://ucarecdn.com/' + j.file + '/' + encodeURIComponent(f.name));
            } catch (e) {}
            reject('bad-response');
          };
          x.onerror = function () { reject('network'); };
          x.send(fd);
        });
      }
      function canShareFile(f) {
        try { return !!(navigator.canShare && navigator.share && navigator.canShare({ files: [f] })); } catch (e) { return false; }
      }
      function showFallback(f) {
        if (fileOk) fileOk.hidden = true;
        if (fileNote) fileNote.hidden = false;
        if (shareBtn) shareBtn.hidden = !canShareFile(f);
      }
      if (shareBtn) shareBtn.addEventListener('click', function () {
        if (!sessionFile) return;
        navigator.share({ files: [sessionFile], text: buildWhatsAppMessage() }).then(function () {
          dl('design_file_shared', { name: sessionFile.name });
        }).catch(function () {});
      });
      if (fileIn) fileIn.addEventListener('change', function () {
        var f = fileIn.files && fileIn.files[0];
        if (!f) return;
        var okExt = /\.(png|jpe?g|pdf|svg)$/i.test(f.name);
        var okSize = f.size <= 10 * 1024 * 1024;
        if (fileInfo) fileInfo.hidden = false;
        if (!okExt || !okSize) {
          state.fileName = null; state.fileUrl = null; sessionFile = null;
          if (fileInfo) { fileInfo.textContent = !okExt ? 'Formato no admitido. Usa PNG, JPG, PDF o SVG.' : 'El archivo supera los 10 MB.'; fileInfo.classList.add('is-error'); }
          if (fileNote) fileNote.hidden = true;
          if (fileOk) fileOk.hidden = true;
          fileIn.value = '';
          refresh(); return;
        }
        sessionFile = f;
        state.fileName = f.name;
        state.fileUrl = null;
        state.dsrc = 'own';
        if (fileInfo) { fileInfo.textContent = f.name + ' (' + (f.size / 1048576).toFixed(1) + ' MB)'; fileInfo.classList.remove('is-error'); }
        dl('design_file_attached', { name: f.name, size: f.size });
        loadOwnLogo(f);
        applyDsrc(); refresh();
        if (!uploadEndpoint()) { showFallback(f); return; }
        if (fileBar) { fileBar.hidden = false; fileBar.firstElementChild.style.width = '4%'; }
        if (fileInfo) fileInfo.textContent = 'Subiendo ' + f.name + '\u2026';
        uploadFile(f, function (p) { if (fileBar) fileBar.firstElementChild.style.width = Math.max(4, Math.round(p * 100)) + '%'; }).then(function (url) {
          if (sessionFile !== f) return;
          state.fileUrl = url;
          if (fileBar) fileBar.hidden = true;
          if (fileInfo) fileInfo.textContent = f.name + ' \u00b7 subido';
          if (fileNote) fileNote.hidden = true;
          if (fileOk) fileOk.hidden = false;
          dl('design_file_uploaded', { name: f.name });
          refresh();
        }).catch(function (err) {
          if (fileBar) fileBar.hidden = true;
          if (fileInfo) fileInfo.textContent = f.name + ' (no se ha podido subir)';
          dl('design_file_upload_failed', { reason: String(err) });
          showFallback(f);
        });
      });

      /* VERSION_CARLOS: herramientas del logo (vista previa, quitar fondo, un color) */
      var logoTools = cz.querySelector('[data-cz-logo-tools]');
      var logoMsg = cz.querySelector('[data-cz-logo-msg]');
      function syncLogoTools() {
        if (!logoTools) return;
        cz.querySelectorAll('[data-logo-opt]').forEach(function (b) { b.setAttribute('aria-pressed', state.logoOpts[b.getAttribute('data-logo-opt')] ? 'true' : 'false'); });
      }
      function loadOwnLogo(f) {
        ownImg = null; ownLogo = null; ownVer++;
        var isImg = /\.(png|jpe?g|svg)$/i.test(f.name);
        if (logoTools) logoTools.hidden = false;
        if (logoMsg) logoMsg.textContent = isImg ? 'Vista previa de tu logo en la espalda.' : 'Los PDF no se pueden previsualizar: lo revisamos nosotros y te enseñamos el resultado.';
        cz.querySelectorAll('[data-logo-opt]').forEach(function (b) { b.disabled = !isImg; });
        if (!isImg) { requestRender(true); return; }
        var url = URL.createObjectURL(f), im = new Image();
        im.onload = function () { ownImg = im; buildOwnLogo(); ownVer++; if (typeof setView === 'function') { try { setView('back'); } catch (e) {} } requestRender(true); };
        im.onerror = function () { if (logoMsg) logoMsg.textContent = 'No hemos podido leer la imagen para la vista previa, pero el archivo se envía igual.'; };
        im.src = url;
      }
      cz.querySelectorAll('[data-logo-opt]').forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-logo-opt');
          state.logoOpts[k] = !state.logoOpts[k]; save();
          syncLogoTools(); buildOwnLogo(); ownVer++; requestRender(true);
          dl('logo_option', { option: k, on: state.logoOpts[k] });
        });
      });
      syncLogoTools();

      /* VERSION_CARLOS: controles del diseño con nombres */
      var nmTa = cz.querySelector('[data-names-text]'), nmBig = cz.querySelector('[data-names-big]'), nmTit = cz.querySelector('[data-names-title]'), nmFoot = cz.querySelector('[data-names-foot]'), nmInfo = cz.querySelector('[data-names-info]');
      function syncNamesUi() {
        if (nmTa && state.namesText != null && nmTa.value !== state.namesText) nmTa.value = state.namesText;
        if (nmBig) { if (state.namesBig == null) state.namesBig = String(new Date().getMonth() > 6 ? new Date().getFullYear() + 1 : new Date().getFullYear()).slice(2); if (nmBig.value !== state.namesBig) nmBig.value = state.namesBig; }
        if (nmTit && state.namesTitle != null) nmTit.value = state.namesTitle;
        if (nmFoot && state.namesFoot != null) nmFoot.value = state.namesFoot;
        cz.querySelectorAll('[data-names-style]').forEach(function (b) { b.setAttribute('aria-pressed', (state.namesStyle || 'numero') === b.getAttribute('data-names-style') ? 'true' : 'false'); });
        if (nmInfo) {
          var l = namesList(), seen = {}, dup = [];
          l.forEach(function (n) { var k = norm(n.split(' ')[0]); if (seen[k] && dup.indexOf(n.split(' ')[0]) < 0 && n.indexOf(' ') < 0) dup.push(n.split(' ')[0]); seen[k] = (seen[k] || 0) + 1; });
          nmInfo.textContent = l.length ? l.length + (l.length === 1 ? ' nombre' : ' nombres') + (dup.length ? '. Repetidos: ' + dup.join(', ') + ' (añadid la inicial del apellido, p. ej. «Lucía M.»).' : '.') : 'Pegad un nombre por línea o separados por comas.';
          nmInfo.classList.toggle('is-warn', dup.length > 0);
        }
      }
      function onNames() { state.namesText = nmTa ? nmTa.value : state.namesText; state.namesBig = nmBig ? nmBig.value.replace(/[^0-9A-Za-zº'·.-]/g, '').slice(0, 4) : state.namesBig; state.namesTitle = nmTit ? nmTit.value : state.namesTitle; state.namesFoot = nmFoot ? nmFoot.value : state.namesFoot; save(); syncNamesUi(); refresh(); }
      [nmTa, nmBig, nmTit, nmFoot].forEach(function (el) { if (el) el.addEventListener('input', function () { clearTimeout(onNames.t); onNames.t = setTimeout(onNames, 250); }); });
      cz.querySelectorAll('[data-names-style]').forEach(function (b) { b.addEventListener('click', function () { state.namesStyle = b.getAttribute('data-names-style'); save(); syncNamesUi(); refresh(); }); });
      if (state.dsrc === 'names') syncNamesUi();

      var helpBtn = cz.querySelector('[data-cz-help]');
      if (helpBtn) helpBtn.addEventListener('click', function () {
        state.designHelp = !state.designHelp;
        helpBtn.setAttribute('aria-pressed', state.designHelp ? 'true' : 'false');
        if (state.designHelp) state.dsrc = 'own';
        dl('design_help_toggled', { on: state.designHelp });
        applyDsrc(); refresh();
      });

      /* alcance de cada personalizacion */
      state.scopes = state.scopes || {};
      cz.querySelectorAll('[data-scope-of]').forEach(function (pill) {
        var pid = pill.getAttribute('data-scope-of');
        pill.addEventListener('click', function () {
          state.scopes[pid] = pill.getAttribute('data-scope');
          cz.querySelectorAll('[data-scope-of="' + pid + '"]').forEach(function (p2) {
            p2.setAttribute('aria-pressed', p2 === pill ? 'true' : 'false');
          });
          dl('perso_scope_selected', { id: pid, scope: state.scopes[pid] });
          refresh();
        });
      });
      function syncPersoExtras() {
        var sel = state.persos || [];
        state.scopes = state.scopes || {};
        cz.querySelectorAll('[data-perso-extra]').forEach(function (x) {
          var pid = x.getAttribute('data-perso-extra');
          var on = sel.indexOf(pid) > -1;
          x.hidden = !on;
          if (on && !state.scopes[pid]) state.scopes[pid] = 'all';
          if (!on) delete state.scopes[pid];
        });
      }

      /* cuantos sois <-> formulario de presupuesto */
      var sizeIn = cz.querySelector('[data-cz-groupsize]');
      var formNum = cz.querySelector('[data-q-num]');
      if (formNum && sizeIn) {
        var fl = cz.querySelector('label[for="' + formNum.id + '"]');
        formNum.hidden = true; if (fl) fl.hidden = true;
        if (state.personas) { sizeIn.value = state.personas; formNum.value = state.personas; }
        sizeIn.addEventListener('input', function () {
          state.personas = sizeIn.value;
          formNum.value = sizeIn.value;
          refresh();
        });
        formNum.addEventListener('input', function () { sizeIn.value = formNum.value; });
      }

      /* destino */
      var destPills = cz.querySelectorAll('[data-dest]');
      var destCountry = cz.querySelector('[data-dest-country]');
      var destNote = cz.querySelector('[data-dest-note]');
      var paisIn = cz.querySelector('[data-cz-pais]');
      function applyDest() {
        destPills.forEach(function (p2) { p2.setAttribute('aria-pressed', p2.getAttribute('data-dest') === state.destino ? 'true' : 'false'); });
        if (destCountry) destCountry.hidden = state.destino !== 'Internacional';
        if (destNote) destNote.hidden = !state.destino;
      }
      destPills.forEach(function (p2) {
        p2.addEventListener('click', function () {
          var v = p2.getAttribute('data-dest');
          state.destino = state.destino === v ? null : v;   /* v14.2: segundo clic deselecciona */
          if (state.destino !== 'Internacional') state.pais = null;
          dl('destination_selected', { zone: state.destino });
          applyDest(); refresh();
        });
      });
      if (paisIn) paisIn.addEventListener('input', function () { state.pais = paisIn.value.trim(); refresh(); });

      /* estado de pasos: check, resumen y acordeon movil */
      function stepInfo() {
        var persos = state.persos || [];
        var colName = function (hex) {
          if (!hex) return null;
          var sw = cz.querySelector('[data-sw-hex="' + hex.toUpperCase() + '"] .lbl, [data-sw-hex="' + hex.toLowerCase() + '"] .lbl');
          return sw ? sw.textContent : hex.toUpperCase();
        };
        var extras = persos.map(function (id) {
          var c2 = cz.querySelector('[data-perso="' + id + '"]');
          return c2 ? c2.getAttribute('data-perso-label') : id;
        });
        var dsum = null;
        if (state.dsrc === 'own') dsum = state.fileName ? 'Mi dise\u00f1o \u00b7 ' + state.fileName : (state.designHelp ? 'Con ayuda del equipo' : null);
        else if (state.dsrc === 'names') dsum = namesList().length ? 'Lista de nombres · ' + namesList().length : 'Lista de nombres';
        else if (state.design) dsum = state.design;
        return [
          { n: 1, done: !!(state.tier && state.prenda), sum: state.tier ? TIER_LABELS[state.tier] + (state.prendaLabel ? ' \u00b7 ' + state.prendaLabel : '') : null },
          { n: 2, done: !!state.hoodie, sum: colName(state.hoodie) },
          { n: 3, done: !!dsum, sum: dsum },
          { n: 4, done: !!(state.print || state.print2), sum: [state.print ? colName(state.print) : null, state.print2 ? 'Color 2 ' + colName(state.print2) : null].filter(Boolean).join(' · ') || null },
          { n: 5, done: persos.length > 0, sum: extras.length ? extras.join(' \u00b7 ') : null },
          { n: 6, done: Number(state.personas) >= 1, sum: state.personas ? state.personas + ' personas' : null },
          { n: 7, done: !!state.destino && (state.destino !== 'Internacional' || !!state.pais), sum: state.destino ? state.destino + (state.pais ? ' \u00b7 ' + state.pais : '') : null }
        ];
      }
      function syncSteps() {
        syncPersoExtras();
        if (typeof syncSwActive === 'function') syncSwActive();
        var infos = stepInfo();
        infos.forEach(function (info) {
          var step = cz.querySelector('[data-step="' + info.n + '"]');
          if (!step) return;
          step.classList.toggle('is-done', info.done);
          var mark = step.querySelector('[data-step-mark]');
          if (mark) {
            if (info.done) mark.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5l5 5 10-11"/></svg><span class="visually-hidden">Completado</span>';
            else mark.textContent = String(info.n);
          }
          var sumEl = step.querySelector('[data-step-sum]');
          if (sumEl) sumEl.textContent = info.done && info.sum ? info.sum : '';
          if (info.done && !step.contains(document.activeElement)) step.classList.remove('is-open');
        });
        var list = cz.querySelector('[data-cz-summary-list]');
        var wrap = cz.querySelector('[data-cz-summary]');
        if (list && wrap) {
          var items = [];
          infos.forEach(function (info) { if (info.done && info.sum) items.push(info.sum); });
          wrap.hidden = items.length < 2;
          list.innerHTML = '';
          items.forEach(function (txt) {
            var li = document.createElement('li');
            li.textContent = txt;
            list.appendChild(li);
          });
        }
      }
      cz.querySelectorAll('.cz-step[data-step]').forEach(function (step) {
        var label = step.querySelector('.cz-step__label');
        if (label) label.addEventListener('click', function () {
          if (step.classList.contains('is-done')) step.classList.toggle('is-open');
        });
        step.addEventListener('focusin', function () { step.classList.add('is-open'); });
      });

      /* avance suave al siguiente paso tras una eleccion de card */
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* v14.3: la navegacion entre pasos la lleva el asistente paso a paso (ver "WIZARD" mas abajo) */
      function goStep() {}

      /* ===== v12: color por gama, bandera Customly, stepper, nombre sin dato ===== */
      delete state.nombre; /* el nombre individual ya no se solicita ni se pinta */

      var premWrap = cz.querySelector('[data-premium-swatches]');
      var freeWrap = cz.querySelector('[data-free-color]');
      var colorNote = cz.querySelector('[data-color-invalid]');
      function premiumPaletteFor(g) {
        var out = [];
        if (!premWrap) return out;
        premWrap.querySelectorAll('[data-sw-hex]').forEach(function (b) {
          var of = b.getAttribute('data-sw-for') || '';
          if (!g || of.indexOf(g) > -1) out.push({ hex: (b.getAttribute('data-sw-hex') || '').toUpperCase(), btn: b });
        });
        return out;
      }
      function applyColorMode() {
        var ultra = state.tier === 'ultra';
        if (premWrap) premWrap.hidden = ultra;
        if (freeWrap) freeWrap.hidden = !ultra;
        if (premWrap && !ultra) {
          var g = state.prenda || null;
          premWrap.querySelectorAll('[data-sw-hex]').forEach(function (b) {
            var of = b.getAttribute('data-sw-for') || '';
            b.hidden = !!g && of.indexOf(g) === -1;
          });
        }
      }
      /* v14.3: Ultra Premium tiene paleta cerrada (30 colores) */
      function ultraPalette() {
        var out = [];
        var uw = cz.querySelector('[data-ultra-swatches]');
        if (uw) uw.querySelectorAll('[data-sw-hex]').forEach(function (b) { out.push({ hex: (b.getAttribute('data-sw-hex') || '').toUpperCase(), btn: b }); });
        return out;
      }
      function validateGarmentColor() {
        if (!state.hoodie) { if (colorNote) colorNote.hidden = true; return; }
        var pal = state.tier === 'ultra' ? ultraPalette() : premiumPaletteFor(state.prenda);
        if (!pal.length) { if (colorNote) colorNote.hidden = true; return; }
        var okc = pal.some(function (c) { return c.hex === String(state.hoodie).toUpperCase(); });
        if (!okc) {
          state.hoodie = null;
          if (colorNote) colorNote.hidden = false;
          if (typeof refresh === 'function') refresh();
        } else if (colorNote) colorNote.hidden = true;
      }
      function syncSwActive() {
        var cur = state.hoodie ? String(state.hoodie).toUpperCase() : null;
        cz.querySelectorAll('[data-step="2"] [data-sw-hex]').forEach(function (b) {
          b.setAttribute('aria-pressed', cur && (b.getAttribute('data-sw-hex') || '').toUpperCase() === cur ? 'true' : 'false');
        });
        if (colorNote && state.hoodie) colorNote.hidden = true;
      }
      tierCards.forEach(function (c) {
        c.addEventListener('click', function () { applyColorMode(); validateGarmentColor(); });
      });
      cz.querySelectorAll('[data-prenda]').forEach(function (c) {
        c.addEventListener('click', function () { applyColorMode(); validateGarmentColor(); });
      });

      /* dropdown de bandera Customly */
      var flagDd = cz.querySelector('[data-flag-dd]');
      if (flagDd) {
        var flagBtn = flagDd.querySelector('[data-flag-btn]');
        var flagList = flagDd.querySelector('[data-flag-list]');
        var flagCur = flagDd.querySelector('[data-flag-current]');
        function closeFlag() { if (flagList) flagList.hidden = true; if (flagBtn) flagBtn.setAttribute('aria-expanded', 'false'); }
        if (flagBtn) flagBtn.addEventListener('click', function () {
          var open = flagList && flagList.hidden;
          if (flagList) flagList.hidden = !open;
          flagBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        var flagPlaceholder = flagCur ? flagCur.textContent : '';
        function syncFlagOpts() {
          flagDd.querySelectorAll('[data-flag-opt]').forEach(function (o2) {
            o2.setAttribute('aria-selected', o2.getAttribute('data-flag-opt') === state.bandera ? 'true' : 'false');
          });
        }
        flagDd.querySelectorAll('[data-flag-opt]').forEach(function (opt) {
          opt.addEventListener('click', function () {
            var v = opt.getAttribute('data-flag-opt');
            if (state.bandera === v) {
              /* v14.1: volver a pulsar la bandera elegida la quita (opcional) */
              state.bandera = null;
              if (flagCur) flagCur.textContent = flagPlaceholder;
              dl('flag_cleared', {});
            } else {
              state.bandera = v;
              if (flagCur) flagCur.textContent = state.bandera;
              dl('flag_selected', { flag: state.bandera });
            }
            syncFlagOpts();
            closeFlag();
            refresh();
          });
        });
        syncFlagOpts();
        document.addEventListener('click', function (e) { if (!flagDd.contains(e.target)) closeFlag(); });
        flagDd.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeFlag(); if (flagBtn) flagBtn.focus(); } });
        if (state.bandera && state.bandera !== 'Sin bandera' && flagCur) flagCur.textContent = state.bandera;
      }

      /* stepper de cantidad */
      var qtyMinus = cz.querySelector('[data-qty-minus]');
      var qtyPlus = cz.querySelector('[data-qty-plus]');
      function bumpQty(d) {
        if (!sizeIn) return;
        var v = parseInt(sizeIn.value, 10);
        if (!isFinite(v)) v = d > 0 ? 4 : 6;
        v = Math.max(5, v + d);
        sizeIn.value = String(v);
        sizeIn.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (qtyMinus) qtyMinus.addEventListener('click', function () { bumpQty(-1); });
      if (qtyPlus) qtyPlus.addEventListener('click', function () { bumpQty(1); });

      cz.querySelectorAll('[data-cp-toggle]').forEach(function (tg) {
        var target = cz.querySelector('.cp[data-cp="' + tg.getAttribute('data-cp-toggle') + '"]');
        if (!target) return;
        tg.addEventListener('click', function () {
          var open = target.hidden;
          target.hidden = !open;
          tg.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      applyColorMode(); validateGarmentColor(); syncSwActive();

            applyTier(); applyDsrc(); applyDest(); syncSteps();

      /* ===== v14.3 WIZARD: un paso cada vez, avance automatico al elegir y boton claro para volver ===== */
      (function wizard() {
        var stepsWrap = cz.querySelector('.cz-steps');
        if (!stepsWrap) return;
        var steps = Array.prototype.slice.call(stepsWrap.querySelectorAll('.cz-step[data-step]'));
        var quote = stepsWrap.querySelector('.cz-step--quote');
        if (quote) { quote.setAttribute('data-wiz-final', ''); steps.push(quote); }
        var summary = cz.querySelector('[data-cz-summary]');
        var TOTAL = steps.length;
        var TITLES = steps.map(function (s) {
          var l = s.querySelector('.cz-step__label');
          if (!l) return '';
          var c = l.cloneNode(true);
          c.querySelectorAll('[data-step-mark],[data-step-sum],em').forEach(function (x) { x.remove(); });
          return c.textContent.replace(/\s+/g, ' ').trim();
        });
        /* obligatorios: 1 (gama + prenda), 2 (color) y 6 (cuantos sois). El resto se puede saltar */
        var OPTIONAL = { 3: 1, 4: 1, 5: 1, 7: 1 };
        cz.classList.add('cz-wizard');

        /* barra de progreso */
        var bar = document.createElement('div');
        bar.className = 'wiz-bar';
        bar.innerHTML = '<p class="wiz-bar__txt" aria-live="polite"><span data-wiz-count></span> <strong data-wiz-title></strong></p>' +
          '<ol class="wiz-dots" role="list"></ol><div class="wiz-track" aria-hidden="true"><span data-wiz-fill></span></div>';
        stepsWrap.insertBefore(bar, stepsWrap.firstChild);
        var dots = bar.querySelector('.wiz-dots');
        steps.forEach(function (s, i) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'wiz-dot'; b.textContent = String(i + 1);
          b.setAttribute('aria-label', 'Ir al paso ' + (i + 1) + ': ' + TITLES[i]);
          b.addEventListener('click', function () { if (!b.disabled) go(i, true); });
          li.appendChild(b); dots.appendChild(li);
        });

        /* botones Atras / Siguiente en cada paso */
        steps.forEach(function (s, i) {
          var nav = document.createElement('div');
          nav.className = 'wiz-nav';
          var back = document.createElement('button');
          back.type = 'button'; back.className = 'wiz-back';
          back.innerHTML = '<span aria-hidden="true">&larr;</span> Atrás';
          back.hidden = i === 0;
          back.addEventListener('click', function () { go(i - 1, true); });
          nav.appendChild(back);
          if (i < TOTAL - 1) {
            var next = document.createElement('button');
            next.type = 'button'; next.className = 'btn btn--cta btn--arrow wiz-next';
            next.setAttribute('data-wiz-next', String(i));
            next.addEventListener('click', function () { if (!next.disabled) go(i + 1, true); });
            nav.appendChild(next);
          }
          (s.querySelector('.cz-step__body') || s).appendChild(nav);
        });

        function done(i) {
          var info = stepInfo();
          var n = i + 1;
          if (n > info.length) return true;
          return !!info[i].done;
        }
        function maxReachable() {
          /* se puede ir hasta el primer paso obligatorio sin completar */
          for (var i = 0; i < TOTAL - 1; i++) { if (!done(i) && !OPTIONAL[i + 1]) return i; }
          return TOTAL - 1;
        }
        var cur = Math.max(0, Math.min(TOTAL - 1, parseInt(state.wizStep, 10) || 0));
        function render() {
          var lim = maxReachable();
          if (cur > lim) cur = lim;
          steps.forEach(function (s, i) {
            s.classList.toggle('is-current', i === cur);
            s.classList.add('is-open');
          });
          if (summary) summary.classList.toggle('is-final', cur === TOTAL - 1);
          bar.querySelector('[data-wiz-count]').textContent = 'Paso ' + (cur + 1) + ' de ' + TOTAL + ' ·';
          bar.querySelector('[data-wiz-title]').textContent = TITLES[cur];
          bar.querySelector('[data-wiz-fill]').style.width = Math.round(((cur + 1) / TOTAL) * 100) + '%';
          dots.querySelectorAll('.wiz-dot').forEach(function (b, i) {
            b.disabled = i > lim;
            b.classList.toggle('is-done', i < TOTAL - 1 && done(i));
            b.setAttribute('aria-current', i === cur ? 'step' : 'false');
          });
          stepsWrap.querySelectorAll('[data-wiz-next]').forEach(function (b) {
            var i = parseInt(b.getAttribute('data-wiz-next'), 10);
            var ok = done(i) || OPTIONAL[i + 1];
            b.disabled = !ok;
            b.textContent = (OPTIONAL[i + 1] && !done(i)) ? 'Saltar este paso' : (i + 1 === TOTAL - 1 ? 'Ver mi presupuesto' : 'Siguiente');
          });
          state.wizStep = cur; save();
        }
        function go(i, fromUser) {
          cur = Math.max(0, Math.min(TOTAL - 1, i));
          render();
          if (fromUser) {
            var target = steps[cur];
            var top = target.getBoundingClientRect().top;
            var vh = window.innerHeight;
            /* solo desplaza si el paso ha quedado fuera de la vista (en movil la vista previa va fija arriba) */
            if (top < 60 || top > vh * 0.75) {
              var off = (parseFloat(getComputedStyle(cz.querySelector('.customizer__preview')).getPropertyValue('--cz-sticky-top')) || 72);
              var compact = window.innerWidth <= 940 ? Math.min(230, vh * 0.26) + 70 : 0;
              window.scrollTo({ top: window.pageYOffset + top - off - compact - 8, behavior: reduced ? 'auto' : 'smooth' });
            }
            var focusEl = target.querySelector('.cz-step__label');
            if (focusEl) { focusEl.setAttribute('tabindex', '-1'); try { focusEl.focus({ preventScroll: true }); } catch (e) {} }
          }
          dl('wizard_step', { step: cur + 1, title: TITLES[cur] });
        }
        function advance(fromIdx) {
          setTimeout(function () {
            if (cur === fromIdx && done(fromIdx)) go(fromIdx + 1, true);
          }, 380);
        }
        /* avance automatico tras elegir (no al deseleccionar) */
        cz.querySelectorAll('[data-prenda]').forEach(function (c) { c.addEventListener('click', function () { if (state.prenda) advance(0); }); });
        cz.querySelectorAll('[data-step="2"] [data-sw-hex]').forEach(function (c) { c.addEventListener('click', function () { if (state.hoodie) advance(1); }); });
        cz.querySelectorAll('[data-design-card]').forEach(function (c) { c.addEventListener('click', function () { if (state.design) advance(2); }); });
        var helpB = cz.querySelector('[data-cz-help]');
        if (helpB) helpB.addEventListener('click', function () { if (state.designHelp) advance(2); });
        cz.querySelectorAll('[data-dest]').forEach(function (c) { c.addEventListener('click', function () { if (state.destino && state.destino !== 'Internacional') advance(6); }); });
        /* cualquier cambio de estado refresca la barra (habilitar Siguiente, puntos completados) */
        var _sync = syncSteps;
        syncSteps = function () { _sync(); try { render(); } catch (e) {} };
        render();
      })();

      state.source = 'configurator';
      filterDesigns();
      refresh();
    });
  });

  window.CUSTOMLY.getPricingForQuantity = getPricingForQuantity;
  window.CUSTOMLY.buildLeadPayload = buildLeadPayload;
  window.CUSTOMLY.buildWaMessage = buildWaMessage;
  window.CUSTOMLY.buildWhatsAppMessage = buildWhatsAppMessage;
  window.CUSTOMLY.buildWhatsAppUrl = buildWhatsAppUrl;
})();
